/* eslint-disable @typescript-eslint/ban-types */
import { CheckboxFormat } from '@shared/enums/CheckboxFormat';
import { CloneRepeatType } from '@shared/enums/CloneRepeatType';
import { CurrencyType } from '@shared/enums/CurrencyType';
import { CustomContactFieldType } from '@shared/enums/CustomContactFieldType';
import { CustomFieldType, StandardFieldType, TimeSlotIcsSetting } from '@shared/enums/CustomFieldType';
import { EventMailType } from '@shared/enums/EventMailType';
import { EventPageType } from '@shared/enums/EventPageType';
import { EventType } from '@shared/enums/EventType';
import { ExcelExistingEmailAddressType } from '@shared/enums/ExcelExistingEmailAddressType';
import { FreeTextFormat } from '@shared/enums/FreeTextFormat';
import { ImportExistingContactType } from '@shared/enums/ImportExistingContactType';
import { ImportExistingCrmIdType, ImportExistingExternalIdType } from '@shared/enums/ImportExistingCrmIdType';
import { ImportExistingEmailAddressType } from '@shared/enums/ImportExistingEmailAddressType';
import { IntegrationCategoryType } from '@shared/enums/IntegrationCategoryType';
import { NoteType } from '@shared/enums/NoteType';
import { PaymentProviderType } from '@shared/enums/PaymentProviderType';
import { PlatformType } from '@shared/enums/PlatformType';
import { SelectFormat } from '@shared/enums/SelectFormat';
import { SurveyQuestionType } from '@shared/enums/SurveyQuestionType';
import { TaskStatusType } from '@shared/enums/TaskStatusType';
import { TicketDistribution } from '@shared/enums/TicketDistribution';
import { TicketLayout } from '@shared/enums/TicketLayout';
import { TicketMailType } from '@shared/enums/TicketMailType';
import { VenueType } from '@shared/enums/VenueType';
import { WebHookOAuthAuthenticationType } from '@shared/enums/WebHookOAuthAuthenticationType';
import { ICalendarLocales } from '@shared/models/calender-locales-model';
import { DropdownModelBoolean } from '@shared/models/dropdown-boolean-model';
import { DropdownModelDisabled } from '@shared/models/dropdown-disabled-model';
import { DropdownModelFacilities } from '@shared/models/dropdown-facilities-model';
import { DropdownModel } from '@shared/models/dropdown-model';
import { DropdownModelString } from '@shared/models/dropdown-string-model';
import { ITimezoneLabels } from '@shared/models/timezone-labels-model';
import { ActivityTimeRange } from '@shared/services/activity-service/activity.models';
import { ActivityCategory as ConActivityCategory } from '@shared/services/api/dashboard/contacts-service/contacts-model';
import { ActivityCategory as EvnActivityCategory } from '@shared/services/api/dashboard/events-service/events-model';
import { ActivityCategory as UserActivityCategory } from '@shared/services/api/dashboard/users-service/users-model';
import { ActivityCategory as EvnInvActivityCategory } from '@shared/services/api/dashboard/invitations-service/invitations-model';
import { ActivityCategory as EvnAttActivityCategory } from '@shared/services/api/dashboard/attendees-service/attendees-model';
import { ActivityCategory as EvnTicketActivityCategory } from '@shared/services/api/dashboard/e-ticket-service/e-ticket.model';
import { FrontDeskLocationAccessType } from '@shared/services/api/dashboard/frontdesk-locations-service/frontdesk-locations.model';
import { IIntegrationStatusPayment, IPaymentChargeAmount, PaymentChargeAmount } from '@shared/services/api/dashboard/integrations-service/integrations-model';
import { ILanguage, ILanguages } from '@shared/services/api/legacy/languages-service/languages-model';
import { PermissionService } from '@shared/services/permission-service/permission.service';
import * as moment from 'moment';
import { ToggleFilterType } from '@shared/enums/ToggleFilterType.enum';
import { ScannerActionType } from '@shared/enums/ScannerActionType';
import { SupportPeriodType } from '@shared/enums/SupportPeriodType';
import { GalleryAccessType } from '@shared/enums/GalleryAccessType';
import { CustomEventFieldType } from '@shared/enums/CustomEventFieldType';
import { ReportPeriodType } from '@shared/enums/ReportPeriodType';
import { ReportFolderType, ReportType } from '@shared/enums/ReportType';
import { NotificationType } from '@shared/enums/NotificationType';
import { ActivityCategory as TenantAttActivityCategory } from '@shared/services/api/dashboard/activitylogs-service/activitylogs-model';
import { QuestionDisplayType } from '@shared/enums/QuestionDisplayType';
import { FooterLayoutType } from '@shared/enums/FooterLayoutType';
import { EventPublishType } from '@shared/enums/EventPublishType';
import { ContentContextType } from '@shared/enums/ContentContextType';
import { AlignmentType } from '@shared/enums/AlignmentType';
import { ContentMediaType } from '@shared/enums/ContentMediaType';
import { MenuPositionType } from '@shared/enums/MenuPositionType';
import { FooterCopyMode } from '@shared/enums/FooterCopyMode';
import { MultiVenueType } from '@shared/enums/MultiVenueType';
import { MaxVenueType } from '@shared/enums/MaxVenueType';
import { SpeakersPageDisplayType } from '@shared/enums/SpeakersPageDisplayType';
import { WorkshopsPageDisplayType } from '@shared/enums/WorkshopsPageDisplayType';
import { CopyMode } from '@shared/enums/CopyMode';
import { ImportInvitationColumnLevel } from '@shared/enums/ImportInvitationColumnLevel';
import { OverwriteType } from '@shared/enums/OverwriteType';
import { DynamicGroupApplicationScope } from '@shared/enums/DynamicGroupApplicationScope';
import { IGetUserProvisioning } from '@shared/services/api/dashboard/user-provisionings-service/user-provsionings-model';
import { UserProvisioningType } from '@shared/enums/UserProvisioningType';
import { UserProvisioningMode } from '@shared/enums/UserProvisioningMode';
import { PublicEventSsoMode } from '@shared/enums/PublicEventSsoMode';
import { PublicEventSsoAuthType } from '@shared/enums/PublicEventSsoAuthType';
import { PublicEventSsoAttribute } from '@shared/enums/PublicEventSsoAttribute';

// Company
export const CompanyName = 'InviteDesk';
export const SupportEmail = 'support@invitedesk.com';
export const SupportHelpcenter = 'https://support.invitedesk.com/';
export const SupportTimezone = 'CET';
export const PublicApi = 'InviteDesk public api';
export const InviteDeskDnsDomain = 'invitedesk.com';

// Services
export const AzureActiveDirectory = 'Active Directory';
export const Okta = 'Okta';
export const ProvisioningService = 'Provisioning Service';

// Languages
export const DefaultLanguage = 'en';
export const DefaultLocale = 'en-gb';

// Buttons
export const MaxLengthButtonText = 50;

// Images
export const DefaultImageLogo = 'assets/img/placeholder_logo.png';
export const DefaultImageBanner = 'assets/img/placeholder_banner.png';
export const LogoFileSize = '2MB';
export const BannerImageFileSize = '2MB';
export const BannerVideoFileSize = '10MB';
export const LogoSizeWidth = '1200px';
export const LogoSizeHeight = '200px';
export const BannerSizeWidth = '1200px';
export const BannerSizeHeight = '400px';
export const RegistrationPageMaxWidth = 1200;

// File extensions
export const AcceptedImages = '.jpg,.jpeg,.png,.webp,.avif';
export const AcceptedAnimatedImages = '.gif,.apng,.avif,.webp';
export const AcceptedVideos = '.mp4';

// Fonts
export const DefaultFont = 'Source Sans Pro';

// Webhooks
export const DefaultWebhookMaxEventsPerBatch = 1;
export const DefaultWebhookPreferredBatchSize = 64;
export const DefaultWebhookMaxDelivery = 10;
export const DefaultWebhookTimeToLive = 1440;

// Documents
export const DocumentationAAD = 'https://invitedesk.com/app/uploads/2026/10/InviteDesk-Microsoft-Entra-ID-integration-guide.pdf';
export const DocumentationOkta = 'https://invitedesk.com/app/uploads/2026/10/InviteDesk-Okta-Integration-guide.pdf';
// Upload
export const MaxUploadedFileSizeRegistrationPage = 4194304;

// Restrictions files and emails
export const MaxFileSizeMail = '4MB';
export const FileFormatsMail = 'jpeg, jpg, png, txt, csv, pdf, doc, docx, xml, xls, xlsx, ppt, pptx, pps, ppsx';
export const MaxFileAmountMail = '3';
export const MaxSizeMail = '10MB';

// Contact Column Guids
export const SmsPermissionColumnId = '47eef5c6-9556-4308-862b-2041cf9efb33';

// Payment charge amounts
export const PaymentChargeAmounts: IPaymentChargeAmount[] = [
    // Stripe
    new PaymentChargeAmount(PaymentProviderType.Stripe, CurrencyType.AUD, 0.5, 999999.99),
    new PaymentChargeAmount(PaymentProviderType.Stripe, CurrencyType.CAD, 0.5, 999999.99),
    new PaymentChargeAmount(PaymentProviderType.Stripe, CurrencyType.CHF, 0.5, 999999.99),
    new PaymentChargeAmount(PaymentProviderType.Stripe, CurrencyType.EUR, 0.5, 999999.99),
    new PaymentChargeAmount(PaymentProviderType.Stripe, CurrencyType.GBP, 0.3, 999999.99),
    new PaymentChargeAmount(PaymentProviderType.Stripe, CurrencyType.NOK, 3, 999999.99),
    new PaymentChargeAmount(PaymentProviderType.Stripe, CurrencyType.SEK, 3, 999999.99),
    new PaymentChargeAmount(PaymentProviderType.Stripe, CurrencyType.USD, 0.5, 999999.99)
];

export function AllLanguages(translation): DropdownModelString[] {
    const languages =
        [
            new DropdownModelString('de', translation.instant('LANGUAGE.GERMAN')),
            new DropdownModelString('en', translation.instant('LANGUAGE.ENGLISH-US')),
            new DropdownModelString('en-gb', translation.instant('LANGUAGE.ENGLISH-GB')),
            new DropdownModelString('fr', translation.instant('LANGUAGE.FRENCH')),
            new DropdownModelString('nl', translation.instant('LANGUAGE.DUTCH')),
            new DropdownModelString('sv', translation.instant('LANGUAGE.SWEDISH')),
            new DropdownModelString('es', translation.instant('LANGUAGE.SPANISH')),
            new DropdownModelString('it', translation.instant('LANGUAGE.ITALIAN')),
            new DropdownModelString('nb', translation.instant('LANGUAGE.NORWEGIAN')),
            new DropdownModelString('da', translation.instant('LANGUAGE.DANISH')),
            new DropdownModelString('lt', translation.instant('LANGUAGE.LITHUANIAN')),
            new DropdownModelString('fi', translation.instant('LANGUAGE.FINNISH')),
            new DropdownModelString('lv', translation.instant('LANGUAGE.LATVIAN')),
            new DropdownModelString('cs', translation.instant('LANGUAGE.CZECH')),
            new DropdownModelString('sl', translation.instant('LANGUAGE.SLOVENIAN')),
            new DropdownModelString('ru', translation.instant('LANGUAGE.RUSSIAN')),
            new DropdownModelString('uk', translation.instant('LANGUAGE.UKRAINIAN')),
            new DropdownModelString('tr', translation.instant('LANGUAGE.TURKISH')),
            new DropdownModelString('el', translation.instant('LANGUAGE.GREEK')),
            new DropdownModelString('pt', translation.instant('LANGUAGE.PORTUGUESE')),
            new DropdownModelString('pl', translation.instant('LANGUAGE.POLISH')),
            new DropdownModelString('sk', translation.instant('LANGUAGE.SLOVAK')),
        ];
    return languages;
}

export function Localisations(translation): DropdownModelString[] {
    const languages =
        [
            new DropdownModelString('de', translation.instant('LOCALISATION.de')),
            new DropdownModelString('en', translation.instant('LOCALISATION.en')),
            new DropdownModelString('en-gb', translation.instant('LOCALISATION.en-gb')),
            new DropdownModelString('fr', translation.instant('LOCALISATION.fr')),
            new DropdownModelString('nl', translation.instant('LOCALISATION.nl')),
            new DropdownModelString('sv', translation.instant('LOCALISATION.sv')),
            new DropdownModelString('es', translation.instant('LOCALISATION.es')),
            new DropdownModelString('it', translation.instant('LOCALISATION.it')),
            new DropdownModelString('nb', translation.instant('LOCALISATION.nb')),
            new DropdownModelString('da', translation.instant('LOCALISATION.da')),
            new DropdownModelString('lt', translation.instant('LOCALISATION.lt')),
            new DropdownModelString('fi', translation.instant('LOCALISATION.fi')),
            new DropdownModelString('lv', translation.instant('LOCALISATION.lv')),
            new DropdownModelString('cs', translation.instant('LOCALISATION.cs')),
            new DropdownModelString('sl', translation.instant('LOCALISATION.sl')),
            new DropdownModelString('ru', translation.instant('LOCALISATION.ru')),
            new DropdownModelString('uk', translation.instant('LOCALISATION.uk')),
            new DropdownModelString('tr', translation.instant('LOCALISATION.tr')),
            new DropdownModelString('el', translation.instant('LOCALISATION.el')),
            new DropdownModelString('pt', translation.instant('LOCALISATION.pt')),
            new DropdownModelString('pl', translation.instant('LOCALISATION.pl')),
            new DropdownModelString('sk', translation.instant('LOCALISATION.sk')),
        ];
    return languages;
}

export function Languages(translation): DropdownModelString[] {
    const languages =
        [
            new DropdownModelString('de', translation.instant('LANGUAGE.GERMAN')),
            new DropdownModelString('en', translation.instant('LANGUAGE.ENGLISH')),
            new DropdownModelString('fr', translation.instant('LANGUAGE.FRENCH')),
            new DropdownModelString('nl', translation.instant('LANGUAGE.DUTCH')),
            new DropdownModelString('sv', translation.instant('LANGUAGE.SWEDISH')),
            new DropdownModelString('es', translation.instant('LANGUAGE.SPANISH')),
            new DropdownModelString('it', translation.instant('LANGUAGE.ITALIAN')),
            new DropdownModelString('nb', translation.instant('LANGUAGE.NORWEGIAN')),
            new DropdownModelString('da', translation.instant('LANGUAGE.DANISH')),
            new DropdownModelString('lt', translation.instant('LANGUAGE.LITHUANIAN')),
            new DropdownModelString('fi', translation.instant('LANGUAGE.FINNISH')),
            new DropdownModelString('lv', translation.instant('LANGUAGE.LATVIAN')),
            new DropdownModelString('cs', translation.instant('LANGUAGE.CZECH')),
            new DropdownModelString('sl', translation.instant('LANGUAGE.SLOVENIAN')),
            new DropdownModelString('ru', translation.instant('LANGUAGE.RUSSIAN')),
            new DropdownModelString('uk', translation.instant('LANGUAGE.UKRAINIAN')),
            new DropdownModelString('tr', translation.instant('LANGUAGE.TURKISH')),
            new DropdownModelString('el', translation.instant('LANGUAGE.GREEK')),
            new DropdownModelString('pt', translation.instant('LANGUAGE.PORTUGUESE')),
            new DropdownModelString('pl', translation.instant('LANGUAGE.POLISH')),
            new DropdownModelString('sk', translation.instant('LANGUAGE.SLOVAK')),
        ];
    return languages;
}

export function DynamicLanguages(translation, langs: ILanguage[]): DropdownModelString[] {
    const languages = [];
    langs.forEach(el => {
        languages.push(
            new DropdownModelString(el.languageId, translation.instant('LANGUAGE.' + el.languageId))
        );
    });
    return languages;
}

export function DynamicLanguagesSettings(translation, langs: ILanguages): DropdownModelString[] {
    const languages = [];
    langs.languages.forEach(el => {
        languages.push(
            new DropdownModelString(el.languageId, translation.instant('LANGUAGE.' + el.languageId))
        );
    });
    return languages;
}

export function DynamicDisclamerPositionSettings(translation): DropdownModel[] {
    const disclamerPositionList =
        [
            new DropdownModel(1, translation.instant('ROUTES.SETTINGS.DATA.PRIVACY.DISCLAMER.POSITION.ABOVE')),
            new DropdownModel(2, translation.instant('ROUTES.SETTINGS.DATA.PRIVACY.DISCLAMER.POSITION.LEFT')),
            new DropdownModel(3, translation.instant('ROUTES.SETTINGS.DATA.PRIVACY.DISCLAMER.POSITION.RIGHT')),
            new DropdownModel(4, translation.instant('ROUTES.SETTINGS.DATA.PRIVACY.DISCLAMER.POSITION.UNDER'))
        ];
    return disclamerPositionList;
}
export function DynamicDisclamerPositionPlaceholder(translation): string {
    return translation.instant('ROUTES.SETTINGS.DATA.PRIVACY.DISCLAMER.POSITION.PLACEHOLDER');
}

export function AlphabetFilterType(translation): DropdownModel[] {
    const alphabetFilterTypesList =
        [
            new DropdownModel(0, translation.instant('ALPHABETFILTER.FIRSTNAME.ATTENDEE')),
            new DropdownModel(1, translation.instant('ALPHABETFILTER.LASTNAME.ATTENDEE')),
            new DropdownModel(2, translation.instant('ALPHABETFILTER.FIRSTNAME.INVITEE')),
            new DropdownModel(3, translation.instant('ALPHABETFILTER.LASTNAME.INVITEE'))
        ];
    return alphabetFilterTypesList;
}

export function BooleanTranslations(translation): DropdownModelBoolean[] {
    const booleanTranslationsList =
        [
            new DropdownModelBoolean(true, translation.instant('SHARED.COMPONENTS.BUTTON.YES')),
            new DropdownModelBoolean(false, translation.instant('SHARED.COMPONENTS.BUTTON.NO'))
        ];
    return booleanTranslationsList;
}

export function ContactTypes(translation): DropdownModel[] {
    const contactTypesList =
        [
            new DropdownModel(1, translation.instant('CONTACTTYPE.EMPLOYEES')),
            new DropdownModel(2, translation.instant('CONTACTTYPE.BUSINESS'))
        ];
    return contactTypesList;
}

export function ContactTypesForSmartFields(translation): DropdownModelString[] {
    const contactTypesList =
        [
            new DropdownModelString('1', translation.instant('CONTACTTYPE.EMPLOYEES')),
            new DropdownModelString('2', translation.instant('CONTACTTYPE.BUSINESS'))
        ];
    return contactTypesList;
}

export function ImportDoubleEmailExcelTypes(translation): DropdownModel[] {
    const importDoubleEmailExcelTypesList =
        [
            new DropdownModel(1, translation.instant('IMPORT.DOUBLES.EXCEL.UPLOADALL')),
            new DropdownModel(2, translation.instant('IMPORT.DOUBLES.EXCEL.UPLOADFIRST'))
        ];
    return importDoubleEmailExcelTypesList;
}

export function ImportDoubleEmailDataBaseTypes(translation): DropdownModel[] {
    const importDoubleEmailDataBaseTypesList =
        [
            new DropdownModel(1, translation.instant('IMPORT.DOUBLES.DB.ADD')),
            new DropdownModel(2, translation.instant('IMPORT.DOUBLES.DB.UPDATE'))
        ];
    return importDoubleEmailDataBaseTypesList;
}

export function Genders(translation): DropdownModelString[] {
    const gendersList =
        [
            new DropdownModelString('male', translation.instant('GENDER.MALE')),
            new DropdownModelString('female', translation.instant('GENDER.FEMALE')),
            new DropdownModelString('unknown', translation.instant('GENDER.UNKNOWN'))
        ];
    return gendersList;
}

export function EventsFilter(translation): DropdownModel[] {
    const eventsFilterList =
        [
            new DropdownModel(1, translation.instant('FILTER.EVENTS.FUTURE')),
            new DropdownModel(2, translation.instant('FILTER.EVENTS.FUTUREDRAFT')),
            new DropdownModel(3, translation.instant('FILTER.EVENTS.PASTDRAFT')),
            new DropdownModel(4, translation.instant('FILTER.EVENTS.SOFTDELETED')),
            new DropdownModel(5, translation.instant('FILTER.EVENTS.ARCHIVED'))
        ];
    return eventsFilterList;
}

export function EventsSort(translation): DropdownModel[] {
    const eventsSortList =
        [
            new DropdownModel(1, translation.instant('SORT.EVENTS.DATEASCENDING')),
            new DropdownModel(2, translation.instant('SORT.EVENTS.DATEDESCENDING')),
            new DropdownModel(3, translation.instant('SORT.EVENTS.NAMEASCENDING')),
            new DropdownModel(4, translation.instant('SORT.EVENTS.NAMEDESCENDING')),
            new DropdownModel(5, translation.instant('SORT.EVENTS.CREATIONDATEASCENDING')),
            new DropdownModel(6, translation.instant('SORT.EVENTS.CREATIONDATEDESCENDING'))
        ];
    return eventsSortList;
}

export function UsersFilter(translation): DropdownModel[] {
    const usersFilterList =
        [
            new DropdownModel(0, translation.instant('FILTER.USERS.ACTIVE')),
            new DropdownModel(1, translation.instant('FILTER.USERS.INACTIVE'))
        ];
    return usersFilterList;
}

export function PublicPagesFilter(translation): DropdownModel[] {
    const publicPagesFilterList =
        [
            new DropdownModel(0, translation.instant('FILTER.PUBLICPAGES.ACTIVE')),
            new DropdownModel(1, translation.instant('FILTER.PUBLICPAGES.INACTIVE'))
        ];
    return publicPagesFilterList;
}

export function ContactsFilter(translation): DropdownModel[] {
    const contactsFilterList =
        [
            new DropdownModel(0, translation.instant('FILTER.CONTACTS.ACTIVE')),
            new DropdownModel(1, translation.instant('FILTER.CONTACTS.INACTIVE'))
        ];
    return contactsFilterList;
}

export function FacilityTypes(translation): DropdownModelFacilities[] {
    const facilityTypesList =
        [
            new DropdownModelFacilities(0, 'fa fa-cutlery', translation.instant('EVENT.FACILITY.FOOD')),
            new DropdownModelFacilities(1, 'fa fa-glass', translation.instant('EVENT.FACILITY.DRINKS')),
            new DropdownModelFacilities(2, 'fa fa-car', translation.instant('EVENT.FACILITY.PARKING')),
            new DropdownModelFacilities(3, 'fa fa-bed', translation.instant('EVENT.FACILITY.HOTEL'))
        ];
    return facilityTypesList;
}

export function EventTypes(translation, locale: string): DropdownModel[] {
    let eventTypesList =
        [
            new DropdownModel(EventType.Convention, translation.instant('EVENT.CONVENTION')),
            new DropdownModel(EventType.Congress, translation.instant('EVENT.CONGRESS')),
            new DropdownModel(EventType.DiningDrinks, translation.instant('EVENT.DININGDRINKS')),
            new DropdownModel(EventType.Museum, translation.instant('EVENT.MUSEUM')),
            new DropdownModel(EventType.Music, translation.instant('EVENT.MUSIC')),
            new DropdownModel(EventType.OpenHouse, translation.instant('EVENT.OPENHOUSE')),
            new DropdownModel(EventType.Travel, translation.instant('EVENT.TRAVEL')),
            new DropdownModel(EventType.SeminarTraining, translation.instant('EVENT.SEMINARTRAINING')),
            new DropdownModel(EventType.SportsGames, translation.instant('EVENT.SPORTSGAMES')),
            new DropdownModel(EventType.Theater, translation.instant('EVENT.THEATER')),
            new DropdownModel(EventType.Webinar, translation.instant('EVENT.WEBINAR')),
            new DropdownModel(EventType.Showroom, translation.instant('EVENT.SHOWROOM')),
            new DropdownModel(EventType.Hybrid, translation.instant('EVENT.HYBRID'))
        ];
    eventTypesList = eventTypesList.sort((a, b) => a.text.localeCompare(b.text, locale));
    return eventTypesList;
}

export function NoteTypes(translation): DropdownModel[] {
    const noteTypesList =
        [
            new DropdownModel(NoteType.Note, translation.instant('NOTETYPE.NOTE')),
            new DropdownModel(NoteType.Task, translation.instant('NOTETYPE.TASK'))
        ];
    return noteTypesList;
}

export function TaskStatusTypes(translation): DropdownModel[] {
    const taskStatusTypesList =
        [
            new DropdownModel(TaskStatusType.Todo, translation.instant('TASKSTATUSTYPE.TODO')),
            new DropdownModel(TaskStatusType.Closed, translation.instant('TASKSTATUSTYPE.CLOSED')),
            new DropdownModel(TaskStatusType.Overdue, translation.instant('TASKSTATUSTYPE.OVERDUE'))
        ];
    return taskStatusTypesList;
}

export function Currencies(): DropdownModel[] {
    const currenciesList =
        [
            new DropdownModel(CurrencyType.Undefined, ''),
            new DropdownModel(CurrencyType.CAD, 'CAD'),
            new DropdownModel(CurrencyType.CHF, 'CHF'),
            new DropdownModel(CurrencyType.EUR, 'EUR'),
            new DropdownModel(CurrencyType.GBP, 'GBP'),
            new DropdownModel(CurrencyType.NOK, 'NOK'),
            new DropdownModel(CurrencyType.SEK, 'SEK'),
            new DropdownModel(CurrencyType.USD, 'USD'),
            new DropdownModel(CurrencyType.AUD, 'AUD')
        ];
    return currenciesList;
}

export function StatusInvitee(translation): DropdownModel[] {
    const statusInviteeList =
        [
            new DropdownModel(3, translation.instant('LEGEND.LABEL.WAITING')),
            new DropdownModel(2, translation.instant('LEGEND.LABEL.PENDING')),
            new DropdownModel(1, translation.instant('LEGEND.LABEL.CONFIRMED')),
            new DropdownModel(4, translation.instant('LEGEND.LABEL.DECLINED')),
            new DropdownModel(5, translation.instant('LEGEND.LABEL.EXPIRED')),
            new DropdownModel(7, translation.instant('LEGEND.LABEL.CANCELLED')),
            new DropdownModel(6, translation.instant('LEGEND.LABEL.RESERVED')),
            new DropdownModel(8, translation.instant('LEGEND.LABEL.WAITINGLIST'))
        ];
    return statusInviteeList;
}

export function StatusInviteeHistory(translation): DropdownModel[] {
    const statusEventHistoryList =
        [
            new DropdownModel(3, translation.instant('LEGEND.LABEL.WAITING')),
            new DropdownModel(2, translation.instant('LEGEND.LABEL.PENDING')),
            new DropdownModel(1, translation.instant('LEGEND.LABEL.CONFIRMED')),
            new DropdownModel(4, translation.instant('LEGEND.LABEL.DECLINEDEXPIREDCANCELLED'))
        ];
    return statusEventHistoryList;
}

export function MailStatusInvitee(translation): DropdownModel[] {
    const mailStatusInviteeList =
        [
            new DropdownModel(0, ''),
            new DropdownModel(1, translation.instant('MAILSTATUS.LABEL.UNKNOWN')),
            new DropdownModel(2, translation.instant('MAILSTATUS.LABEL.QUEUED')),
            new DropdownModel(3, translation.instant('MAILSTATUS.LABEL.SENT')),
            new DropdownModel(4, translation.instant('MAILSTATUS.LABEL.OPENED')),
            new DropdownModel(5, translation.instant('MAILSTATUS.LABEL.CLICKED')),
            new DropdownModel(6, translation.instant('MAILSTATUS.LABEL.BOUNCE')),
            new DropdownModel(7, translation.instant('MAILSTATUS.LABEL.SPAM')),
            // new DropdownModel(8, translation.instant('MAILSTATUS.LABEL.UNSUB')),
            new DropdownModel(9, translation.instant('MAILSTATUS.LABEL.BLOCKED')),
            new DropdownModel(10, translation.instant('MAILSTATUS.LABEL.HARDBOUNCED')),
            new DropdownModel(11, translation.instant('MAILSTATUS.LABEL.SOFTBOUNCED')),
            new DropdownModel(12, translation.instant('MAILSTATUS.LABEL.DEFERRED')),
            new DropdownModel(13, translation.instant('MAILSTATUS.LABEL.NOTPROCESSED'))
        ];
    return mailStatusInviteeList;
}

export function MailStatusFilter(translation): DropdownModel[] {
    const mailStatusFilterList =
        [
            new DropdownModel(2, translation.instant('MAILSTATUS.LABEL.QUEUED')),
            new DropdownModel(3, translation.instant('MAILSTATUS.LABEL.SENT')),
            new DropdownModel(4, translation.instant('MAILSTATUS.LABEL.OPENED')),
            new DropdownModel(5, translation.instant('MAILSTATUS.LABEL.CLICKED')),
            new DropdownModel(6, translation.instant('MAILSTATUS.LABEL.BOUNCE')),
            new DropdownModel(7, translation.instant('MAILSTATUS.LABEL.SPAM')),
            // new DropdownModel(8, translation.instant('MAILSTATUS.LABEL.UNSUB')),
            new DropdownModel(9, translation.instant('MAILSTATUS.LABEL.BLOCKED')),
            new DropdownModel(13, translation.instant('MAILSTATUS.LABEL.NOTPROCESSED'))
        ];
    return mailStatusFilterList;
}

export function StatusAttendee(translation): DropdownModel[] {
    const statusAttendeeList =
        [
            new DropdownModel(2, translation.instant('LEGEND.LABEL.REGISTERED')),
            new DropdownModel(1, translation.instant('LEGEND.LABEL.CHECKEDIN')),
            new DropdownModel(4, translation.instant('LEGEND.LABEL.CHECKEDOUT')),
            new DropdownModel(3, translation.instant('LEGEND.LABEL.NOSHOW'))
        ];
    return statusAttendeeList;
}

export function StatusAttendeeTickets(translation): DropdownModel[] {
    const statusAttendeeTicketsList =
        [
            // new DropdownModel(0, ''),
            new DropdownModel(1, translation.instant('TICKETMAILSTATUS.LABEL.ASSIGNED')),
            new DropdownModel(2, translation.instant('TICKETMAILSTATUS.LABEL.SENT')),
            new DropdownModel(3, translation.instant('TICKETMAILSTATUS.LABEL.UPDATED')),
            new DropdownModel(4, translation.instant('TICKETMAILSTATUS.LABEL.ASSIGNED/UPDATED'))
        ];
    return statusAttendeeTicketsList;
}

export function ChartColorScheme(type: string) {
    const chartColorSchemeAllocation = {
        domain: ['#27c24c', '#ff902b', '#2581C4', '#f05050']
    };
    const chartColorSchemeInvitatee = {
        domain: ['#27c24c', '#ff902b', '#2581C4', '#f05050', '#f05050']
    };
    const chartColorSchemeAttendee = {
        domain: ['#27c24c', '#2581C4', '#f05050']
    };
    switch (type) {
        case 'allocation':
            return chartColorSchemeAllocation;
        case 'invitee':
            return chartColorSchemeInvitatee;
        case 'attendee':
            return chartColorSchemeAttendee;
    }
}

export function Alignment(translation): any[] {
    const alignmentList =
        [
            new DropdownModelString('left', translation.instant('ALIGNMENT.LEFT')),
            new DropdownModelString('center', translation.instant('ALIGNMENT.CENTER')),
            new DropdownModelString('right', translation.instant('ALIGNMENT.RIGHT'))
        ];
    return alignmentList;
}

export function Fonts(translation, customFonts = []): any[] {
    let fontsList =
        [
            {
                category: translation.instant('FONT.RECOMMENDED'),
                children: [
                    { value: 'Gothic A1' },
                    { value: 'Lato' },
                    { value: 'Montserrat' },
                    { value: 'Open Sans' },
                    { value: 'PT Sans' },
                    { value: 'Raleway' },
                    { value: 'Roboto' },
                    { value: 'Source Sans Pro' }
                ]
            },
            {
                category: translation.instant('FONT.CLASSIC'),
                children: [
                    { value: 'Arial' },
                    { value: 'Georgia' },
                    { value: 'Helvetica' },
                    { value: 'Lucida' },
                    { value: 'Tahoma' },
                    { value: 'Times New Roman' },
                    { value: 'Trebuchet MS' },
                    { value: 'Verdana' }
                ]
            }
        ];

    if (customFonts?.length > 0) {
        const customFontsListChildren = [];
        customFonts.forEach(customFont => {
            customFontsListChildren.push(
                { value: customFont.text }
            );
        });
        const customFontsList = [
            {
                category: translation.instant('FONT.CUSTOM'),
                children: customFontsListChildren
            }
        ];
        fontsList = customFontsList.concat(fontsList);
    }

    return fontsList;
}

export function Sender(translation): DropdownModel[] {
    const senderList =
        [
            new DropdownModel(1, translation.instant('SENDER.TICKETHOLDER')),
            new DropdownModel(2, translation.instant('SENDER.SPECIFIC'))
        ];
    return senderList;
}

export function SenderCampaign(translation): DropdownModel[] {
    const senderList =
        [
            new DropdownModel(1, translation.instant('SENDER.SENDER')),
            new DropdownModel(2, translation.instant('SENDER.SPECIFIC'))
        ];
    return senderList;
}

export function ReplyTo(translation): DropdownModel[] {
    const replyToList =
        [
            new DropdownModel(1, translation.instant('REPLYTO.SAME')),
            new DropdownModel(2, translation.instant('REPLYTO.SPECIFIC'))
        ];
    return replyToList;
}

export function InvitationProcess(translation): DropdownModel[] {
    const invitationProcessList =
        [
            new DropdownModel(1, translation.instant('INVITATIONPROCESS.ONE')),
            new DropdownModel(2, translation.instant('INVITATIONPROCESS.ALL'))
        ];
    return invitationProcessList;
}

export function SenderConfirmation(translation): DropdownModel[] {
    const thankYouSenderList =
        [
            new DropdownModel(1, translation.instant('SENDER.CONFIRMATION.MAIN')),
            new DropdownModel(2, translation.instant('SENDER.CONFIRMATION.ALL'))
        ];
    return thankYouSenderList;
}

export function SenderWelcome(translation): DropdownModel[] {
    const thankYouSenderList =
        [
            new DropdownModel(1, translation.instant('SENDER.WELCOME.MAIN')),
            new DropdownModel(2, translation.instant('SENDER.WELCOME.ALL'))
        ];
    return thankYouSenderList;
}

export function SenderThankYou(translation): DropdownModel[] {
    const thankYouSenderList =
        [
            new DropdownModel(1, translation.instant('SENDER.THANKYOU.MAIN.REGISTERED')),
            new DropdownModel(2, translation.instant('SENDER.THANKYOU.MAIN.ATTENDED')),
            new DropdownModel(3, translation.instant('SENDER.THANKYOU.ALL.REGISTERED')),
            new DropdownModel(4, translation.instant('SENDER.THANKYOU.ALL.ATTENDED'))
        ];
    return thankYouSenderList;
}

export function SenderTicket(translation): DropdownModel[] {
    const thankYouSenderList =
        [
            new DropdownModel(1, translation.instant('SENDER.WELCOME.MAIN')),
            new DropdownModel(2, translation.instant('SENDER.WELCOME.ALL'))
        ];
    return thankYouSenderList;
}

export function SenderPaymentDocument(translation): DropdownModel[] {
    const paymentDocumentSenderList =
        [
            new DropdownModel(1, translation.instant('SENDER.PAYMENTDOCUMENT.MAIN.REGISTERED')),
            new DropdownModel(2, translation.instant('SENDER.PAYMENTDOCUMENT.MAIN.ATTENDED')),
            new DropdownModel(3, translation.instant('SENDER.PAYMENTDOCUMENT.ALL.REGISTERED')),
            new DropdownModel(4, translation.instant('SENDER.PAYMENTDOCUMENT.ALL.ATTENDED'))
        ];
    return paymentDocumentSenderList;
}

export function TargetGroup(translation): any[] {
    const targetGroupList = [
        {
            text: translation.instant('LEGEND.LABEL.INVITATION'),
            children: [
                { id: 3, text: translation.instant('LEGEND.LABEL.WAITING') },
                { id: 2, text: translation.instant('LEGEND.LABEL.PENDING') },
                { id: 1, text: translation.instant('LEGEND.LABEL.CONFIRMED') },
                { id: 4, text: translation.instant('LEGEND.LABEL.DECLINED') },
                { id: 7, text: translation.instant('LEGEND.LABEL.EXPIRED') },
                { id: 8, text: translation.instant('LEGEND.LABEL.CANCELLED') }
            ]
        },
        {
            text: translation.instant('LEGEND.LABEL.ATTENDEE'),
            children: [
                { id: 9, text: translation.instant('LEGEND.LABEL.REGISTERED') },
                { id: 5, text: translation.instant('LEGEND.LABEL.CHECKEDIN') },
                { id: 6, text: translation.instant('LEGEND.LABEL.NOSHOW') }
            ]
        },
    ];
    return targetGroupList;
}

export function DocumentType(translation): DropdownModel[] {
    const documentTypeList =
        [
            new DropdownModel(1, translation.instant('LEGEND.LABEL.SIGNATURE')),
            new DropdownModel(2, translation.instant('LEGEND.LABEL.BADGE')),
            new DropdownModel(3, translation.instant('LEGEND.LABEL.CERTIFICATE')),
        ];
    return documentTypeList;
}

export function DocumentSize(translation): DropdownModel[] {
    const documentSizeList =
        [
            new DropdownModel(1, translation.instant('LEGEND.LABEL.A4')),
            new DropdownModel(3, translation.instant('LEGEND.LABEL.CUSTOM')),
        ];
    return documentSizeList;
}

export function DynamicSegmentApplicationScope(translation): DropdownModel[] {
    const dynamicSegmentApplicationScopeList =
        [
            new DropdownModel(1, translation.instant('INPUT.MAININVITEEGUEST.LABEL')),
            new DropdownModel(2, translation.instant('INPUT.MAININVITEE.LABEL')),
            new DropdownModel(3, translation.instant('INPUT.GUESTS.LABEL')),
        ];
    return dynamicSegmentApplicationScopeList;
}

export function AmountOfGuests(amount: number, translation): DropdownModel[] {
    const amountOfGuestsList = [];

    for (let i = 0; i < amount; i++) {
        if (i === 0) {
            amountOfGuestsList.push(new DropdownModel(i, translation.instant('PERSON.SINGLE')));
        } else {
            amountOfGuestsList.push(new DropdownModel(i, i + 1 + ' ' + translation.instant('PERSON.MULTIPLE')));
        }

    }

    return amountOfGuestsList;
}

export function Overbooking(translation): DropdownModel[] {
    const overbookingList =
        [
            new DropdownModel(0, translation.instant('OVERBOOKING.NONE')),
            new DropdownModel(1, translation.instant('OVERBOOKING.UNLIMITED'))
        ];
    return overbookingList;
}

export function Timezones(translation): any[] {
    const timezonesList = [
        {
            text: translation.instant('TIMEZONE.CONTINENT.EUROPE'),
            children: [
                // { id: 'Azores Standard Time', text: '(UTC-01:00) Azores'},
                { id: 'GMT Standard Time', text: '(UTC+00:00) London, Lisbon' },
                { id: 'W. Europe Standard Time', text: '(UTC+01:00) Brussels, Amsterdam' },
                { id: 'FLE Standard Time', text: '(UTC+02:00) Helsinki, Athens' },
                // { id: 'Russian Standard Time', text: '(UTC+03:00) Moscow, Riyadh'}
            ]
        },
        {
            text: translation.instant('TIMEZONE.CONTINENT.NORTHAMERICA'),
            children: [
                // { id: 'Hawaiian Standard Time', text: '(UTC-10:00) Hawaii'},
                // { id: 'Alaskan Standard Time', text: '(UTC-09:00) Alaska'},
                { id: 'Pacific Standard Time', text: '(UTC-08:00) Pacific Time (US and Canada)' },
                { id: 'Mountain Standard Time', text: '(UTC-07:00) Mountain Time (US and Canada)' },
                { id: 'Central Standard Time', text: '(UTC-06:00) Central Time (US and Canada)' },
                { id: 'Eastern Standard Time', text: '(UTC-05:00) Eastern Time (US and Canada)' },
                // { id: 'Atlantic Standard Time', text: '(UTC-04:00) Atlantic Time (Canada), Santiago'},
                // { id: 'Newfoundland and Labrador Standard Time', text: '(UTC-03:30) Newfoundland and Labrador'},
            ]
        },
        {
            text: translation.instant('TIMEZONE.CONTINENT.SOUTHAMERICA'),
            children: [
                // { id: 'S.A. Pacific Standard Time', text: '(UTC-05:00) Bogota, Lima, Quito'},
                // { id: 'S.A. Western Standard Time', text: '(UTC-04:00) Caracas, La Paz'},
                { id: 'E. South America Standard Time', text: '(UTC-03:00) Brasilia, Buenos Aires, Georgetown' },
            ]
        },
        {
            text: translation.instant('TIMEZONE.CONTINENT.MIDDLEEAST'),
            children: [
                // { id: 'Arabic Standard Time', text: '(UTC+03:00) Baghdad'},
                // { id: 'Iran Standard Time', text: '(UTC+03:30) Tehran'},
                { id: 'Arabian Standard Time', text: '(UTC+04:00) Abu Dhabi, Muscat'}
            ]
        },
        {
            text: translation.instant('TIMEZONE.CONTINENT.ASIA'),
            children: [
                // { id: 'West Asia Standard Time', text: '(UTC+05:00) Islamabad, Karachi, Tashkent'},
                // { id: 'India Standard Time', text: '(UTC+05:30) Chennai, Kolkata, Mumbai, New Delhi'},
                // { id: 'Central Asia Standard Time', text: '(UTC+06:00) Astana, Dhaka'},
                { id: 'SE Asia Standard Time', text: '(UTC+07:00) Bangkok, Hanoi, Jakarta' },
                { id: 'China Standard Time', text: '(UTC+08:00) Beijing, Chongqing, Hong Kong SAR, Urumqi' },
                // { id: 'Korea Standard Time', text: '(UTC+09:00) Seoul, Osaka, Sapporo, Tokyo'},
                // { id: 'Vladivostok Standard Time', text: '(UTC+10:00) Vladivostok'}
            ]
        },
        // {
        //     text: translation.instant('TIMEZONE.CONTINENT.AUSTRALIA'),
        //     children: [
        //         { id: 'W. Australia Standard Time', text: '(UTC+08:00) Perth'},
        //         { id: 'Cen. Australia Standard Time', text: '(UTC+09:30) Darwin, Adelaide'},
        //         { id: 'E. Australia Standard Time', text: '(UTC+10:00) Canberra, Melbourne, Sydney, Brisbane'},
        //         { id: 'Central Pacific Standard Time', text: '(UTC+11:00) Magadan, Solomon Islands, New Caledonia'},
        //         { id: 'New Zealand Standard Time', text: '(UTC+12:00) Auckland, Wellington'}
        //     ]
        // }
    ];
    return timezonesList;
}

export function FreetextFormats(translation): any {
    const freetextFormatsList = [
        {
            id: FreeTextFormat.Text,
            text: translation.instant('ROUTES.EVENTDETAIL.TIMELINE.REGISTRATIONPAGE.FORM.CUSTOM.FORMAT.TEXT'),
        },
        {
            id: FreeTextFormat.Number,
            text: translation.instant('ROUTES.EVENTDETAIL.TIMELINE.REGISTRATIONPAGE.FORM.CUSTOM.FORMAT.NUMBER'),
        },
        {
            id: FreeTextFormat.Date,
            text: translation.instant('ROUTES.EVENTDETAIL.TIMELINE.REGISTRATIONPAGE.FORM.CUSTOM.FORMAT.DATE'),
        },
        {
            id: FreeTextFormat.Time,
            text: translation.instant('ROUTES.EVENTDETAIL.TIMELINE.REGISTRATIONPAGE.FORM.CUSTOM.FORMAT.TIME'),
        },
        {
            id: FreeTextFormat.CountryCode,
            text: translation.instant('ROUTES.EVENTDETAIL.TIMELINE.REGISTRATIONPAGE.FORM.CUSTOM.FORMAT.COUNTRYCODE'),
        }
    ];
    return freetextFormatsList;
}

export function CheckboxFormats(translation): any {
    const checkboxFormatsList = [
        {
            id: CheckboxFormat.OptIn,
            text: translation.instant('ROUTES.EVENTDETAIL.TIMELINE.REGISTRATIONPAGE.FORM.CUSTOM.FORMAT.OPTIN'),
        },
        {
            id: CheckboxFormat.OptOut,
            text: translation.instant('ROUTES.EVENTDETAIL.TIMELINE.REGISTRATIONPAGE.FORM.CUSTOM.FORMAT.OPTOUT'),
        }
    ];
    return checkboxFormatsList;
}

export function TicketLayouts(translation): any {
    const ticketLayoutsList = [
        {
            id: TicketLayout.Badge,
            text: translation.instant('ROUTES.EVENTDETAIL.TICKETS.FORM.SELECT.LAYOUT.BADGE'),
            disabled: false
        },
        {
            id: TicketLayout.A4,
            text: translation.instant('ROUTES.EVENTDETAIL.TICKETS.FORM.SELECT.LAYOUT.A4'),
            disabled: false
        }
    ];
    return ticketLayoutsList;
}
export function TicketDistributionDropdown(translation): any {
    const ticketDistributionDropdownList = [
        // TODO ukrinsoft: uncomment after add newfunctionality
        // {
        //     id: TicketDistribution.Automated,
        //     text: translation.instant('ROUTES.EVENTDETAIL.TICKETS.FORM.SELECT.DISTRIBUTION.AUTOMATED'),
        //     disabled: true
        // },
        {
            id: TicketDistribution.Manual,
            text: translation.instant('ROUTES.EVENTDETAIL.TICKETS.FORM.SELECT.DISTRIBUTION.MANUAL'),
            disabled: false

        }
    ];
    return ticketDistributionDropdownList;
}

export function ETicketDistributionDropdown(translation): any {
    return [
        {
            id: TicketDistribution.Automated,
            text: translation.instant('ROUTES.EVENTDETAIL.TICKETS.FORM.SELECT.DISTRIBUTION.AUTOMATED'),
            disabled: false
        },
        {
            id: TicketDistribution.InviteeOnly,
            text: translation.instant('ROUTES.EVENTDETAIL.TICKETS.FORM.SELECT.DISTRIBUTION.AUTOMATEDINVITEE'),
            disabled: false
        },
        {
            id: TicketDistribution.Manual,
            text: translation.instant('ROUTES.EVENTDETAIL.TICKETS.FORM.SELECT.DISTRIBUTION.MANUAL'),
            disabled: false
        }
    ];
}

export function FrontDeskLocationAccessTypeDropdown(translation): any {
    return [
        {
            id: FrontDeskLocationAccessType.Matching,
            text: translation.instant('ROUTES.EVENTS.FRONTDESK.LOCATION.ACCESSTYPE.MATCHING'),
            disabled: false
        },
        {
            id: FrontDeskLocationAccessType.All,
            text: translation.instant('ROUTES.EVENTS.FRONTDESK.LOCATION.ACCESSTYPE.ALL'),
            disabled: false

        }
    ];
}

export function TicketMailTypes(translation): any {
    const ticketMailTypesList = [
        {
            id: TicketMailType.WithConfirmation,
            text: translation.instant('ROUTES.EVENTDETAIL.TIMELINE.TICKETMAIL.FORM.TICKETMAILTYPE.WITHCONFIRMATION'),
            disabled: true
        },
        {
            id: TicketMailType.DaysBeforeEvent,
            text: translation.instant('ROUTES.EVENTDETAIL.TIMELINE.TICKETMAIL.FORM.TICKETMAILTYPE.DAYSBEFOREEVENT'),
            disabled: true
        },
        {
            id: TicketMailType.Manual,
            text: translation.instant('ROUTES.EVENTDETAIL.TIMELINE.TICKETMAIL.FORM.TICKETMAILTYPE.MANUAL'),
            disabled: false
        }
    ];
    return ticketMailTypesList;
}

export function GuestsFilterListItems(translation): any {
    const guestsFilterList = [
        {
            text: translation.instant('ROUTES.EVENTDETAIL.TICKETS.GUESTS.FILTER.ITEM.ALL'),
            value: false
        },
        {
            text: translation.instant('ROUTES.EVENTDETAIL.TICKETS.GUESTS.FILTER.ITEM.INVITEE'),
            value: true
        }
    ];
    return guestsFilterList;
}

export function UploadOptionsEventMail(): any {
    const uploadOptionsEventMailList = {
        concurrency: 1,
        maxUploads: 10,
        allowedContentTypes: [
            'image/jpg', 'image/jpeg', 'image/png', 'image/gif',
            'text/plain', 'text/csv', 'application/pdf',
            'application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
            'application/vnd.ms-excel', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            'application/vnd.ms-powerpoint', 'application/vnd.openxmlformats-officedocument.presentationml.presentation',
            'application/vnd.openxmlformats-officedocument.presentationml.slideshow'
        ]
    };
    return uploadOptionsEventMailList;
}

export function UploadOptionsRegistrationPage(): any {
    return {
        concurrency: 3,
        maxUploads: 10,
        allowedContentTypes: [
            'image/jpg', 'image/jpeg', 'image/png', 'image/gif',
            'text/plain', 'text/csv', 'application/pdf',
            'application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
            'application/vnd.ms-excel', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            'application/vnd.ms-powerpoint', 'application/vnd.openxmlformats-officedocument.presentationml.presentation',
            'application/vnd.openxmlformats-officedocument.presentationml.slideshow'
        ]
    };
}

export function UploadOptionsTickets(): any {
    const uploadOptionsTicketsList = {
        concurrency: 0,
        allowedContentTypes: ['application/pdf']
    };
    return uploadOptionsTicketsList;
}

export function UploadOptionsCustomFont(): any {
    const uploadOptionsCustomFontList = {
        concurrency: 1,
        maxUploads: 1,
        allowedContentTypes: [
            'application/font-woff'
        ]
    };
    return uploadOptionsCustomFontList;
}

export function UploadOptionsWebhookCertificate(): any {
    // No allowedContentTypes: browsers report .pfx/.p12 inconsistently (application/x-pkcs12, empty, ...),
    // so the extension is validated in the component instead.
    const uploadOptionsWebhookCertificateList = {
        concurrency: 1,
        maxUploads: 1
    };
    return uploadOptionsWebhookCertificateList;
}

export function UploadGalleryFiles(): any {
    const uploadGalleryFilesList = {
        concurrency: 1,
        // maxUploads: 10,
        allowedContentTypes: [
            'image/jpg', 'image/jpeg', 'image/png', 'image/gif'
        ]
    };
    return uploadGalleryFilesList;
}

export function StandardFieldsDropdownList(translation): any {
    const customFieldsDropdown = [
        {
            id: StandardFieldType.Mobile,
            text: translation.instant('ROUTES.EVENTDETAIL.TIMELINE.REGISTRATIONPAGE.FORM.CUSTOM.DROPDOWN.MOBILE.LABEL'),
            fieldName: 'mobile'
        },
        {
            id: StandardFieldType.Company,
            text: translation.instant('ROUTES.EVENTDETAIL.TIMELINE.REGISTRATIONPAGE.FORM.CUSTOM.DROPDOWN.COMPANY.LABEL'),
            fieldName: 'company'
        },
        {
            id: StandardFieldType.JobTitle,
            text: translation.instant('ROUTES.EVENTDETAIL.TIMELINE.REGISTRATIONPAGE.FORM.CUSTOM.DROPDOWN.JOBTITLE.LABEL'),
            fieldName: 'jobTitle'
        },
        {
            id: StandardFieldType.Address,
            text: translation.instant('ROUTES.EVENTDETAIL.TIMELINE.REGISTRATIONPAGE.FORM.CUSTOM.DROPDOWN.ADDRESS.LABEL'),
            fieldName: 'address'
        },
        {
            id: StandardFieldType.CustomerNumber,
            text: translation.instant('ROUTES.EVENTDETAIL.TIMELINE.REGISTRATIONPAGE.FORM.CUSTOM.DROPDOWN.CUSTOMERNUMBER.LABEL'),
            fieldName: 'customerNumber'
        }
    ];
    return customFieldsDropdown;
}

export function CustomFieldsDropdownList(translation): any {
    const customFieldsDropdown = [
        {
            id: CustomFieldType.FreeText,
            text: translation.instant('ROUTES.EVENTDETAIL.TIMELINE.REGISTRATIONPAGE.FORM.CUSTOM.DROPDOWN.FREETEXT.LABEL'),
            fieldName: ''
        },
        {
            id: CustomFieldType.SingleSelect,
            text: translation.instant('ROUTES.EVENTDETAIL.TIMELINE.REGISTRATIONPAGE.FORM.CUSTOM.DROPDOWN.SINGLE.LABEL'),
            fieldName: ''
        },
        {
            id: CustomFieldType.MultipleSelect,
            text: translation.instant('ROUTES.EVENTDETAIL.TIMELINE.REGISTRATIONPAGE.FORM.CUSTOM.DROPDOWN.MULTIPLE.LABEL'),
            fieldName: ''
        },
        {
            id: CustomFieldType.Boolean,
            text: translation.instant('ROUTES.EVENTDETAIL.TIMELINE.REGISTRATIONPAGE.FORM.CUSTOM.DROPDOWN.BOOLEAN.LABEL'),
            fieldName: ''
        },
        {
            id: CustomFieldType.FileUpload,
            text: translation.instant('ROUTES.EVENTDETAIL.TIMELINE.REGISTRATIONPAGE.FORM.CUSTOM.DROPDOWN.FILEUPLOAD.LABEL'),
            fieldName: ''
        },
        {
            id: CustomFieldType.SignDocument,
            text: translation.instant('ROUTES.EVENTDETAIL.TIMELINE.REGISTRATIONPAGE.FORM.CUSTOM.DROPDOWN.SIGNDOCUMENT.LABEL'),
            fieldName: ''
        }
    ];
    return customFieldsDropdown;
}

export function CustomFieldTemplatesDropdownList(translation: any): any {
    const customFieldsDropdown = [
        {
            id: CustomFieldType.FreeText,
            text: translation.instant('ROUTES.LIBRARY.CUSTOMFIELDTEMPLATE.DROPDOWN.FREETEXT.LABEL'),
            fieldName: ''
        },
        {
            id: CustomFieldType.SingleSelect,
            text: translation.instant('ROUTES.LIBRARY.CUSTOMFIELDTEMPLATE.DROPDOWN.SINGLE.LABEL'),
            fieldName: ''
        },
        {
            id: CustomFieldType.MultipleSelect,
            text: translation.instant('ROUTES.LIBRARY.CUSTOMFIELDTEMPLATE.DROPDOWN.MULTIPLE.LABEL'),
            fieldName: ''
        },
        {
            id: CustomFieldType.Boolean,
            text: translation.instant('ROUTES.LIBRARY.CUSTOMFIELDTEMPLATE.DROPDOWN.BOOLEAN.LABEL'),
            fieldName: ''
        },
        {
            id: CustomFieldType.FileUpload,
            text: translation.instant('ROUTES.LIBRARY.CUSTOMFIELDTEMPLATE.DROPDOWN.FILEUPLOAD.LABEL'),
            fieldName: ''
        },
        {
            id: CustomFieldType.SignDocument,
            text: translation.instant('ROUTES.LIBRARY.CUSTOMFIELDTEMPLATE.DROPDOWN.SIGNDOCUMENT.LABEL'),
            fieldName: ''
        }
    ];
    return customFieldsDropdown;
}

export function CustomSelectFieldsItems(translation): any {
    const customSelectFieldsItemsList = [
        {
            id: CustomFieldType.SingleSelect,
            text: translation.instant('ROUTES.EVENTDETAIL.TIMELINE.REGISTRATIONPAGE.FORM.CUSTOM.DROPDOWN.SINGLE.LABEL'),
        },
        {
            id: CustomFieldType.MultipleSelect,
            text: translation.instant('ROUTES.EVENTDETAIL.TIMELINE.REGISTRATIONPAGE.FORM.CUSTOM.DROPDOWN.MULTIPLE.LABEL'),
        }
    ];
    return customSelectFieldsItemsList;
}

export function SingleSelectFieldsFormat(translation): any {
    return [
        {
            id: SelectFormat.Dropdown,
            text: translation.instant('ROUTES.EVENTDETAIL.TIMELINE.REGISTRATIONPAGE.FORM.CUSTOM.SINGLESELECT.DROPDOWN'),
        },
        {
            id: SelectFormat.CheckboxRadio,
            text: translation.instant('ROUTES.EVENTDETAIL.TIMELINE.REGISTRATIONPAGE.FORM.CUSTOM.SINGLESELECT.RADIOBUTTONS'),
        }
    ];
}

export function MultiSelectFieldsFormat(translation): any {
    return [
        {
            id: SelectFormat.Dropdown,
            text: translation.instant('ROUTES.EVENTDETAIL.TIMELINE.REGISTRATIONPAGE.FORM.CUSTOM.SINGLESELECT.DROPDOWN'),
        },
        {
            id: SelectFormat.CheckboxRadio,
            text: translation.instant('ROUTES.EVENTDETAIL.TIMELINE.REGISTRATIONPAGE.FORM.CUSTOM.SINGLESELECT.CHECKBOXES'),
        }
    ];
}

export function TimeSlotIcsSettingDropDownList(translation): any {
    const configOptions = [
        {
            id: TimeSlotIcsSetting.IgnoreTimeSlots,
            text: translation.instant('ROUTES.EVENTDETAIL.TIMELINE.REGISTRATIONPAGE.FORM.CUSTOM.MULTIPLECHOICE.CONFIG.ICS.IGNORE'),
        },
        {
            id: TimeSlotIcsSetting.ReplaceByTimeSlot,
            text: translation.instant('ROUTES.EVENTDETAIL.TIMELINE.REGISTRATIONPAGE.FORM.CUSTOM.MULTIPLECHOICE.CONFIG.ICS.REPLACE'),
        },
        {
            id: TimeSlotIcsSetting.AddTimeSlots,
            text: translation.instant('ROUTES.EVENTDETAIL.TIMELINE.REGISTRATIONPAGE.FORM.CUSTOM.MULTIPLECHOICE.CONFIG.ICS.ADD'),
        }
    ];
    return configOptions;
}

export function CustomContactFieldsTypes(translation): any {
    const customContactFieldsTypesList = [
        {
            id: CustomContactFieldType.FreeText,
            text: translation.instant('ROUTES.SETTINGS.CUSTOMCONTACTFIELDS.FIELDTYPE.FREETEXT'),
        },
        {
            id: CustomContactFieldType.SingleSelect,
            text: translation.instant('ROUTES.SETTINGS.CUSTOMCONTACTFIELDS.FIELDTYPE.SINGLESELECT'),
        },
        {
            id: CustomContactFieldType.MultipleSelect,
            text: translation.instant('ROUTES.SETTINGS.CUSTOMCONTACTFIELDS.FIELDTYPE.MULTIPLESELECT'),
        },
        {
            id: CustomContactFieldType.Boolean,
            text: translation.instant('ROUTES.SETTINGS.CUSTOMCONTACTFIELDS.FIELDTYPE.BOOLEAN'),
        },
        {
            id: CustomContactFieldType.SingleSelectUser,
            text: translation.instant('ROUTES.SETTINGS.CUSTOMCONTACTFIELDS.FIELDTYPE.SINGLESELECTUSER'),
        },
        {
            id: CustomContactFieldType.MultiSelectUser,
            text: translation.instant('ROUTES.SETTINGS.CUSTOMCONTACTFIELDS.FIELDTYPE.MULTISELECTUSER'),
        },
        {
            id: CustomContactFieldType.SmartField,
            text: translation.instant('ROUTES.SETTINGS.CUSTOMCONTACTFIELDS.FIELDTYPE.SMARTFIELD'),
        },
    ];
    return customContactFieldsTypesList;
}

export function CustomContactOverwriteTypes(translation): any {
    return [
        {
            id: OverwriteType.DoNothing,
            text: translation.instant('ROUTES.SETTINGS.CUSTOMCONTACTFIELDS.OVERWRITETYPE.DONOTHING'),
        },
        {
            id: OverwriteType.FillIfEmpty,
            text: translation.instant('ROUTES.SETTINGS.CUSTOMCONTACTFIELDS.OVERWRITETYPE.FILLIFEMPTY'),
        },
        {
            id: OverwriteType.OverwriteAlways,
            text: translation.instant('ROUTES.SETTINGS.CUSTOMCONTACTFIELDS.OVERWRITETYPE.OVERWRITEALWAYS'),
        },
    ];
}

export function UserlaneRights(permissions: PermissionService): string {
    let rights = 'all';

    if (permissions.hasPermission('team.edit')) {
        rights += 'team.edit';
    }
    if (permissions.hasPermission('user.edit')) {
        rights += 'user.edit';
    }
    if (permissions.hasPermission('profile.edit')) {
        rights += 'profile.edit';
    }
    if (permissions.hasPermission('template.edit')) {
        rights += 'template.edit';
    }

    return rights;
}

export const userlane = {
    loaded: false
};

export function SurveyQuestionTypes(translation): any {
    const surveyQuestionTypesList = [
        {
            id: SurveyQuestionType.FreeText,
            text: translation.instant('SURVEY.QUESTIONTYPE.FREETEXT.LABEL'),
        },
        {
            id: SurveyQuestionType.SingleSelect,
            text: translation.instant('SURVEY.QUESTIONTYPE.SINGLESELECT.LABEL'),
        },
        {
            id: SurveyQuestionType.MultipleSelect,
            text: translation.instant('SURVEY.QUESTIONTYPE.MULTISELECT.LABEL'),
        },
        {
            id: SurveyQuestionType.Score,
            text: translation.instant('SURVEY.QUESTIONTYPE.SCORE.LABEL'),
        },
        {
            id: SurveyQuestionType.NPS,
            text: translation.instant('SURVEY.QUESTIONTYPE.NPS.LABEL'),
        },
        {
            id: SurveyQuestionType.TagCloud,
            text: translation.instant('SURVEY.QUESTIONTYPE.TAGCLOUD.LABEL'),
        }
    ];
    return surveyQuestionTypesList;
}

export function SurveySelectSingleMultiFieldsItems(translation): any {
    const surveySelectSingleMultiFieldsItemsList = [
        {
            id: SurveyQuestionType.SingleSelect,
            text: translation.instant('SURVEY.QUESTIONTYPE.SINGLESELECT.LABEL'),
        },
        {
            id: SurveyQuestionType.MultipleSelect,
            text: translation.instant('SURVEY.QUESTIONTYPE.MULTISELECT.LABEL'),
        }
    ];
    return surveySelectSingleMultiFieldsItemsList;
}

export function CustomFieldTypeSelectSingleMultiFieldsItems(translation): any {
    const surveySelectSingleMultiFieldsItemsList = [
        {
            id: CustomFieldType.SingleSelect,
            text: translation.instant('SURVEY.QUESTIONTYPE.SINGLESELECT.LABEL'),
        },
        {
            id: CustomFieldType.MultipleSelect,
            text: translation.instant('SURVEY.QUESTIONTYPE.MULTISELECT.LABEL'),
        }
    ];
    return surveySelectSingleMultiFieldsItemsList;
}

export function SurveySelectScoreTypeItems(translation: any): any {
    const surveySelectScoreTypeItems = [
        {
            id: QuestionDisplayType.Radio,
            text: translation.instant('SURVEY.QUESTION.SCORE.RADIO.LABEL'),
        },
        {
            id: QuestionDisplayType.Star,
            text: translation.instant('SURVEY.QUESTION.SCORE.STAR_RATING.LABEL'),
        }
    ];
    return surveySelectScoreTypeItems;
}

export function PublicPagePasswordAuthenticationTypes(translation, provisioning: IGetUserProvisioning): DropdownModel[] {
    const authenticationTypesList =
        [
            new DropdownModel(2, translation.instant('AUTHENTICATIONTYPE.CODE')),
        ];

    if (provisioning && provisioning.mode === UserProvisioningMode.UserAndContact) {
        if (provisioning.type === UserProvisioningType.Okta) {
            authenticationTypesList.push(new DropdownModel(4, translation.instant('AUTHENTICATIONTYPE.WORKACCOUNT.OKTA')));
        } else {
            authenticationTypesList.push(new DropdownModel(4, translation.instant('AUTHENTICATIONTYPE.WORKACCOUNT')));
        }
    }

    return authenticationTypesList;
}

export function PublicPageAuthenticationTypes(translation, provisioning: IGetUserProvisioning): DropdownModel[] {
    const authenticationTypesList =
        [
            new DropdownModel(1, translation.instant('AUTHENTICATIONTYPE.NONE')),
            new DropdownModel(2, translation.instant('AUTHENTICATIONTYPE.CODE')),
            new DropdownModel(5, translation.instant('AUTHENTICATIONTYPE.PUBLICEVENTSSO')),
        ];

    if (provisioning) {
        if (provisioning.type === UserProvisioningType.Okta) {
            authenticationTypesList.push(new DropdownModel(4, translation.instant('AUTHENTICATIONTYPE.WORKACCOUNT.OKTA')));
        } else {
            authenticationTypesList.push(new DropdownModel(4, translation.instant('AUTHENTICATIONTYPE.WORKACCOUNT')));
        }
    }

    return authenticationTypesList;
}

export function PublicPageEventPublishTypes(translation): DropdownModel[] {
    const items =
        [
            new DropdownModel(EventPublishType.All, translation.instant('EVENTPUBLISHTYPE.1')),
            new DropdownModel(EventPublishType.Invitees, translation.instant('EVENTPUBLISHTYPE.2')),
        ];

    return items;
}


export function PublicPageTabTypes(translation): DropdownModel[] {
    const publicPageTabTypesList =
        [
            new DropdownModel(1, translation.instant('PUBLICPAGETABTYPE.LIST')),
            new DropdownModel(2, translation.instant('PUBLICPAGETABTYPE.CALENDAR'))
        ];
    return publicPageTabTypesList;
}

export function PublicPageCapacityVisibility(translation): DropdownModel[] {
    const publicPageCapacityVisibility =
        [
            new DropdownModel(1, translation.instant('PUBLICPAGECAPACITYVISIBILITY.ALWAYS')),
            new DropdownModel(2, translation.instant('PUBLICPAGECAPACITYVISIBILITY.NEVER')),
            new DropdownModel(3, translation.instant('PUBLICPAGECAPACITYVISIBILITY.THRESHOLD'))
        ];
    return publicPageCapacityVisibility;
}

export function PublicPageTargets(translation): DropdownModelString[] {
    const publicPageTargetsList =
        [
            new DropdownModelString('_blank', translation.instant('PUBLICPAGETARGET.BLANK')),
            new DropdownModelString('_iframe', translation.instant('PUBLICPAGETARGET.IFRAME'))
        ];
    return publicPageTargetsList;
}

export function AlertFrequencyMailTypes(translation): DropdownModel[] {
    const alertFrequencyMailTypeList =
        [
            new DropdownModel(1, translation.instant('ALERTFREQUENCYTYPE.NONE')),
            new DropdownModel(2, translation.instant('ALERTFREQUENCYTYPE.DAILY')),
            new DropdownModel(3, translation.instant('ALERTFREQUENCYTYPE.WEEKLY'))
        ];
    return alertFrequencyMailTypeList;
}

export function AlertFrequencySmsTypes(translation): DropdownModel[] {
    const alertFrequencySmsTypeList =
        [
            new DropdownModel(1, translation.instant('ALERTFREQUENCYTYPE.NONE')),
            new DropdownModel(3, translation.instant('ALERTFREQUENCYTYPE.WEEKLY'))
        ];
    return alertFrequencySmsTypeList;
}

export function ImportContactExistingCrmIdTypes(translation): DropdownModel[] {
    const importExistingCrmIdTypeList =
        [
            new DropdownModel(ImportExistingCrmIdType.Ignore, translation.instant('TYPE.CONTACT.IGNORE.LABEL')),
            new DropdownModel(ImportExistingCrmIdType.Update, translation.instant('TYPE.CONTACT.UPDATE.LABEL'))
        ];
    return importExistingCrmIdTypeList;
}

export function ImportContactExistingEmailAddressTypes(translation): DropdownModel[] {
    const importExistingEmailAddressTypeList =
        [
            new DropdownModel(ImportExistingEmailAddressType.Ignore, translation.instant('TYPE.CONTACT.EMAIL.IGNORE.LABEL')),
            new DropdownModel(ImportExistingEmailAddressType.Add, translation.instant('TYPE.CONTACT.EMAIL.ADD.LABEL')),
            new DropdownModel(ImportExistingEmailAddressType.Update, translation.instant('TYPE.CONTACT.EMAIL.UPDATE.LABEL'))
        ];
    return importExistingEmailAddressTypeList;
}

export function ImportContactExistingContactTypes(translation): DropdownModel[] {
    const importExistingContactTypeList =
        [
            new DropdownModel(ImportExistingContactType.Ignore, translation.instant('TYPE.CONTACT.IGNORE.LABEL')),
            new DropdownModel(ImportExistingContactType.Update, translation.instant('TYPE.CONTACT.UPDATE.LABEL'))
        ];
    return importExistingContactTypeList;
}

export function ExcelContactExistingEmailAddressTypes(translation): DropdownModel[] {
    const importExistingEmailAddressTypeList =
        [
            new DropdownModel(ExcelExistingEmailAddressType.First, translation.instant('TYPE.CONTACT.FIRST.LABEL')),
            new DropdownModel(ExcelExistingEmailAddressType.All, translation.instant('TYPE.CONTACT.ALL.LABEL'))
        ];
    return importExistingEmailAddressTypeList;
}

export function ImportInvitationExistingCrmIdTypes(translation): DropdownModel[] {
    const importExistingCrmIdTypeList =
        [
            new DropdownModel(ImportExistingCrmIdType.Ignore, translation.instant('TYPE.INVITATION.IGNORE.LABEL')),
            new DropdownModel(ImportExistingCrmIdType.Update, translation.instant('TYPE.INVITATION.UPDATE.LABEL'))
        ];
    return importExistingCrmIdTypeList;
}

export function ImportInvitationExistingExternalIdTypes(translation): DropdownModel[] {
    const importExistingCrmIdTypeList =
        [
            new DropdownModel(ImportExistingExternalIdType.Ignore, translation.instant('TYPE.INVITATION.IGNORE.LABEL')),
            new DropdownModel(ImportExistingExternalIdType.Update, translation.instant('TYPE.INVITATION.UPDATE.LABEL'))
        ];
    return importExistingCrmIdTypeList;
}

export function ImportInvitationExistingEmailAddressTypes(translation): DropdownModel[] {
    const importExistingEmailAddressTypeList =
        [
            new DropdownModel(ImportExistingEmailAddressType.Ignore, translation.instant('TYPE.INVITATION.EMAIL.IGNORE.LABEL')),
            new DropdownModel(ImportExistingEmailAddressType.Add, translation.instant('TYPE.INVITATION.EMAIL.ADD.LABEL')),
            new DropdownModel(ImportExistingEmailAddressType.Update, translation.instant('TYPE.INVITATION.EMAIL.UPDATE.LABEL'))
        ];
    return importExistingEmailAddressTypeList;
}

export function ImportInvitationExistingContactTypes(translation): DropdownModel[] {
    const importExistingContactTypeList =
        [
            new DropdownModel(ImportExistingContactType.Ignore, translation.instant('TYPE.INVITATION.IGNORE.LABEL')),
            new DropdownModel(ImportExistingContactType.Update, translation.instant('TYPE.INVITATION.UPDATE.LABEL'))
        ];
    return importExistingContactTypeList;
}

export function ExcelInvitationExistingEmailAddressTypes(translation): DropdownModel[] {
    const importExistingEmailAddressTypeList =
        [
            new DropdownModel(ExcelExistingEmailAddressType.First, translation.instant('TYPE.INVITATION.FIRST.LABEL')),
            new DropdownModel(ExcelExistingEmailAddressType.All, translation.instant('TYPE.INVITATION.ALL.LABEL'))
        ];
    return importExistingEmailAddressTypeList;
}

export function ActiveQuestionsFilterItems(translation): DropdownModel[] {
    const activeQuestionsFilterItemList =
        [
            new DropdownModel(0, translation.instant('ROUTES.SURVEY.QUESTIONS.FILTER.STATUS.ACTIVEITEM.TITLE')),
            new DropdownModel(1, translation.instant('ROUTES.SURVEY.QUESTIONS.FILTER.STATUS.INACTIVEITEM.TITLE'))
        ];
    return activeQuestionsFilterItemList;
}

export function SurveyQuestionsFilterItemsByType(translation): DropdownModel[] {
    const surveyQuestionsFilterItemByTypeList =
        [
            new DropdownModel(1, translation.instant('SURVEY.QUESTIONTYPE.FREETEXT.LABEL')),
            new DropdownModel(2, translation.instant('SURVEY.QUESTIONTYPE.SINGLESELECT.LABEL')),
            new DropdownModel(3, translation.instant('SURVEY.QUESTIONTYPE.MULTISELECT.LABEL')),
            new DropdownModel(4, translation.instant('SURVEY.QUESTIONTYPE.SCORE.LABEL')),
            new DropdownModel(5, translation.instant('SURVEY.QUESTIONTYPE.NPS.LABEL')),
            new DropdownModel(6, translation.instant('SURVEY.QUESTIONTYPE.TAGCLOUD.LABEL'))
        ];
    return surveyQuestionsFilterItemByTypeList;
}

export function ActiveSurveyTemplatesFilter(translation): DropdownModel[] {
    const usersFilterList =
        [
            new DropdownModel(0, translation.instant('ROUTES.SURVEY.TEMPLATES.FILTER.STATUS.ACTIVEITEM.TITLE')),
            new DropdownModel(1, translation.instant('ROUTES.SURVEY.TEMPLATES.FILTER.STATUS.INACTIVEITEM.TITLE'))
        ];
    return usersFilterList;
}

export function StatisticSurveyPageItems(translation): any {
    const statisticSurveyPageItems =
        [
            {
                id: EventPageType.SurveyPage,
                text: translation.instant('ROUTES.EVENTDETAIL.TIMELINE.SURVEYPAGE.LABEL'),
                disabled: true
            },
            {
                id: EventPageType.SurveyActiveDeclinePage,
                text: translation.instant('ROUTES.EVENTDETAIL.TIMELINE.SURVEYPAGE.DECLINE.ACTIVE.LABEL'),
                disabled: true
            },
            {
                id: EventPageType.SurveyPassiveDeclinePage,
                text: translation.instant('ROUTES.EVENTDETAIL.TIMELINE.SURVEYPAGE.DECLINE.PASSIVE.LABEL'),
                disabled: true
            }
        ];
    return statisticSurveyPageItems;
}

export function PageLayouts(translation): DropdownModel[] {
    const pageLayoutTypesList =
        [
            new DropdownModel(2, translation.instant('PAGELAYOUT.VERTICAL')),
            new DropdownModel(1, translation.instant('PAGELAYOUT.HORIZONTAL'))
        ];
    return pageLayoutTypesList;
}

export function GdprType(translation): DropdownModel[] {
    const pageLayoutTypesList =
        [
            new DropdownModel(1, translation.instant('GDPR.DEFAULT')),
            new DropdownModel(2, translation.instant('GDPR.CUSTOM'))
        ];
    return pageLayoutTypesList;
}

export function ListStatusFilter(translation): DropdownModel[] {
    const listStatusFilterList =
        [
            new DropdownModel(1, translation.instant('LIST.ACTIVE')),
            new DropdownModel(2, translation.instant('LIST.INACTIVE'))
        ];
    return listStatusFilterList;
}

export function ContactMailPermission(translation): DropdownModel[] {
    const contactMailPermissionList =
        [
            new DropdownModel(0, translation.instant('FILTER.CONTACTS.MAILPERMISSION.TRUE')),
            new DropdownModel(1, translation.instant('FILTER.CONTACTS.MAILPERMISSION.FALSE'))
        ];
    return contactMailPermissionList;
}

export function ContactSmsPermission(translation): DropdownModel[] {
    const contactSmsPermissionList =
        [
            new DropdownModel(0, translation.instant('FILTER.CONTACTS.SMSPERMISSION.TRUE')),
            new DropdownModel(1, translation.instant('FILTER.CONTACTS.SMSPERMISSION.FALSE'))
        ];
    return contactSmsPermissionList;
}

export function ListTypes(translation): DropdownModel[] {
    const listTypesList =
        [
            new DropdownModel(1, translation.instant('LIST.PUBLIC')),
            new DropdownModel(2, translation.instant('LIST.PRIVATE'))
        ];
    return listTypesList;
}

export function PlatformTypes(translation): DropdownModel[] {
    const platformTypesList =
        [
            new DropdownModel(PlatformType.PresentAndConnect, translation.instant('PLATFORM.PRESENTANDCONNECT')),
            new DropdownModel(PlatformType.ThirdParty, translation.instant('PLATFORM.THIRDPARTY')),
            new DropdownModel(PlatformType.Zoom, translation.instant('PLATFORM.ZOOM'))
        ];
    return platformTypesList;
}

export function VenueTypes(translation): DropdownModel[] {
    const venueTypesList =
        [
            new DropdownModel(VenueType.LiveEvent, translation.instant('VENUETYPE.LIVEEVENT')),
            new DropdownModel(VenueType.Online, translation.instant('VENUETYPE.ONLINE')),
            // new DropdownModel(VenueType.OnDemand, translation.instant('VENUETYPE.ONDEMAND'))
        ];
    return venueTypesList;
}

export function MultiVenueTypes(translation): DropdownModel[] {
    const multiVenueTypesList =
        [
            new DropdownModel(MultiVenueType.Registration, translation.instant('MULTIVENUE.TYPE.REGISTRATION')),
            new DropdownModel(MultiVenueType.Attendee, translation.instant('MULTIVENUE.TYPE.ATTENDEE')),
        ];
    return multiVenueTypesList;
}

export function MaxVenueTypes(translation): DropdownModel[] {
    const maxVenueTypeList =
        [
            new DropdownModel(MaxVenueType.Registration, translation.instant('MAXVENUE.TYPE.REGISTRATION')),
            new DropdownModel(MaxVenueType.Attendee, translation.instant('MAXVENUE.TYPE.ATTENDEE')),
        ];
    return maxVenueTypeList;
}


// Calendar locale
export function CalendarLocales(language: string): ICalendarLocales {
    const calendarDateFormat = moment.localeData().longDateFormat('L').toLowerCase().replace('yyyy', 'yy');
    const calendarFirstDayOfWeek = moment.localeData().firstDayOfWeek();
    const calendarHourFormat = (language === 'en') ? '12' : '24';
    const calendarHourPlaceholder = moment.localeData().longDateFormat('LT');
    return {
        calendarDateFormat,
        calendarFirstDayOfWeek,
        calendarHourFormat,
        calendarHourPlaceholder
    };
}

export function MailTypeFilter(translation): DropdownModel[] {
    const mailStatusFilterList =
        [
            new DropdownModel(EventMailType.SaveTheDateMail, translation.instant('EVENTMAILTYPE.9')),
            new DropdownModel(EventMailType.InvitationMail, translation.instant('EVENTMAILTYPE.1')),
            new DropdownModel(EventMailType.ReminderMail, translation.instant('EVENTMAILTYPE.3')),
            new DropdownModel(EventMailType.ConfirmationMail, translation.instant('EVENTMAILTYPE.2')),
            new DropdownModel(EventMailType.WelcomeMail, translation.instant('EVENTMAILTYPE.4')),
            new DropdownModel(EventMailType.ThankYouMail, translation.instant('EVENTMAILTYPE.5')),
            new DropdownModel(EventMailType.TicketMail, translation.instant('EVENTMAILTYPE.8')),
            new DropdownModel(EventMailType.AdHocMail, translation.instant('EVENTMAILTYPE.6'))
        ];
    return mailStatusFilterList;
}

export const TimezoneLabels: ITimezoneLabels[] = [
    {
        id: 'GMT Standard Time',
        labels: [
            {
                isDST: true,
                text: 'BST'
            },
            {
                isDST: false,
                text: 'GMT'
            }
        ]
    },
    {
        id: 'W. Europe Standard Time',
        labels: [
            {
                isDST: true,
                text: 'CEST'
            },
            {
                isDST: false,
                text: 'CET'
            }
        ]
    },
    {
        id: 'FLE Standard Time',
        labels: [
            {
                isDST: true,
                text: 'EEST'
            },
            {
                isDST: false,
                text: 'EET'
            }
        ]
    },
    {
        id: 'Pacific Standard Time',
        labels: [
            {
                isDST: true,
                text: 'PT'
            },
            {
                isDST: false,
                text: 'PT'
            }
        ]
    },
    {
        id: 'Mountain Standard Time',
        labels: [
            {
                isDST: true,
                text: 'MT'
            },
            {
                isDST: false,
                text: 'MT'
            }
        ]
    },
    {
        id: 'Central Standard Time',
        labels: [
            {
                isDST: true,
                text: 'CT'
            },
            {
                isDST: false,
                text: 'CT'
            }
        ]
    },
    {
        id: 'Eastern Standard Time',
        labels: [
            {
                isDST: true,
                text: 'ET'
            },
            {
                isDST: false,
                text: 'ET'
            }
        ]
    },
    {
        id: 'E. South America Standard Time',
        labels: [
            {
                isDST: true,
                text: 'ESAST'
            },
            {
                isDST: false,
                text: 'ESAST'
            }
        ]
    },
    {
        id: 'SE Asia Standard Time',
        labels: [
            {
                isDST: true,
                text: 'THA'
            },
            {
                isDST: false,
                text: 'THA'
            }
        ]
    },
    {
        id: 'China Standard Time',
        labels: [
            {
                isDST: true,
                text: 'CST'
            },
            {
                isDST: false,
                text: 'CST'
            }
        ]
    }
];

export function CampaignsFilter(translation): DropdownModel[] {
    const campaignsFilterList =
        [
            new DropdownModel(1, translation.instant('FILTER.CAMPAIGNS.FUTURE')),
            new DropdownModel(2, translation.instant('FILTER.CAMPAIGNS.PAST')),
            new DropdownModel(3, translation.instant('FILTER.CAMPAIGNS.SOFTDELETED'))
        ];
    return campaignsFilterList;
}

export function CampaignsSort(translation): DropdownModel[] {
    const campaignsSortList =
        [
            new DropdownModel(1, translation.instant('SORT.CAMPAIGNS.DATEASCENDING')),
            new DropdownModel(2, translation.instant('SORT.CAMPAIGNS.DATEDESCENDING')),
            new DropdownModel(3, translation.instant('SORT.CAMPAIGNS.NAMEASCENDING')),
            new DropdownModel(4, translation.instant('SORT.CAMPAIGNS.NAMEDESCENDING')),
            new DropdownModel(5, translation.instant('SORT.CAMPAIGNS.CREATIONDATEASCENDING')),
            new DropdownModel(6, translation.instant('SORT.CAMPAIGNS.CREATIONDATEDESCENDING'))
        ];
    return campaignsSortList;
}

export function RecipientsFilter(translation): DropdownModel[] {
    const campaignsFilterList =
        [
            new DropdownModel(1, translation.instant('FILTER.RECIPIENTS.UNPROCESSED')),
            new DropdownModel(2, translation.instant('FILTER.RECIPIENTS.PROCESSED'))
        ];
    return campaignsFilterList;
}

export function WebhookOAuthAuthenticationTypes(translation): any[] {
    const oAuthAuthenticationTypesList = [
        {
            id: WebHookOAuthAuthenticationType.NoOAuth,
            text: translation.instant('ROUTES.INTEGRATION.MODAL.WEBHOOK.ADD.OAUTHSERVER.TYPE.NOAUTH'),
        },
        {
            id: WebHookOAuthAuthenticationType.ClientSecret,
            text: translation.instant('ROUTES.INTEGRATION.MODAL.WEBHOOK.ADD.OAUTHSERVER.TYPE.CLIENTSECRET'),
        },
        {
            id: WebHookOAuthAuthenticationType.ClientCredentialsCertificate,
            text: translation.instant('ROUTES.INTEGRATION.MODAL.WEBHOOK.ADD.OAUTHSERVER.TYPE.CLIENTCREDENTIALSCERTIFICATE'),
        }
    ];
    return oAuthAuthenticationTypesList;
}

export function WebhookEventTypes(translation): any[] {
    const eventTypesList = [
        {
            text: translation.instant('WEBHOOK.EVENTTYPE.ALLOCATION'),
            children: [
                { id: 'AllocationCreatedEvent', text: 'AllocationCreatedEvent' },
                { id: 'AllocationDeletedEvent', text: 'AllocationDeletedEvent' },
                { id: 'AllocationUpdatedEvent', text: 'AllocationUpdatedEvent' }
            ]
        },
        {
            text: translation.instant('WEBHOOK.EVENTTYPE.ATTENDEE'),
            children: [
                { id: 'AttendeeCreatedEvent', text: 'AttendeeCreatedEvent' },
                { id: 'AttendeeDeletedEvent', text: 'AttendeeDeletedEvent' },
                { id: 'AttendeeUpdatedEvent', text: 'AttendeeUpdatedEvent' }
            ]
        },
        {
            text: translation.instant('WEBHOOK.EVENTTYPE.CONTACT'),
            children: [
                { id: 'ContactCreatedEvent', text: 'ContactCreatedEvent' },
                { id: 'ContactDeletedEvent', text: 'ContactDeletedEvent' },
                { id: 'ContactUnsubscribedEvent', text: 'ContactUnsubscribedEvent' },
                { id: 'ContactUpdatedEvent', text: 'ContactUpdatedEvent' }
            ]
        },
        {
            text: translation.instant('WEBHOOK.EVENTTYPE.ADVANCEDTEMPLATE'),
            children: [
                { id: 'DesignTemplateCreatedEvent', text: 'DesignTemplateCreatedEvent' },
                { id: 'DesignTemplateDeletedEvent', text: 'DesignTemplateDeletedEvent' },
                { id: 'DesignTemplateUpdatedEvent', text: 'DesignTemplateUpdatedEvent' }
            ]
        },
        {
            text: translation.instant('WEBHOOK.EVENTTYPE.EVENT'),
            children: [
                { id: 'EventArchivedEvent', text: 'EventArchivedEvent' },
                { id: 'EventCreatedEvent', text: 'EventCreatedEvent' },
                { id: 'EventDeletedEvent', text: 'EventDeletedEvent' },
                { id: 'EventPublishedEvent', text: 'EventPublishedEvent' },
                { id: 'EventUpdatedEvent', text: 'EventUpdatedEvent' }
            ]
        },
        {
            text: translation.instant('WEBHOOK.EVENTTYPE.EVENTPAGE'),
            children: [
                { id: 'EventPageCreatedEvent', text: 'EventPageCreatedEvent' },
                { id: 'EventPageUpdatedEvent', text: 'EventPageUpdatedEvent' }
            ]
        },
        {
            text: translation.instant('WEBHOOK.EVENTTYPE.INVITATION'),
            children: [
                { id: 'InvitationCreatedEvent', text: 'InvitationCreatedEvent' },
                { id: 'InvitationDeletedEvent', text: 'InvitationDeletedEvent' },
                { id: 'InvitationUpdatedEvent', text: 'InvitationUpdatedEvent' }
            ]
        },
        {
            text: translation.instant('WEBHOOK.EVENTTYPE.USER'),
            children: [
                { id: 'UserCreatedEvent', text: 'UserCreatedEvent' },
                { id: 'UserDeletedEvent', text: 'UserDeletedEvent' },
                { id: 'UserUpdatedEvent', text: 'UserUpdatedEvent' }
            ]
        }
    ];
    return eventTypesList;
}

export function Countries(countries, language): DropdownModelString[] {
    const countriesList = [];
    const allCountries = countries.getNames(language);

    // eslint-disable-next-line guard-for-in
    for (const key in allCountries) {
        countriesList.push(new DropdownModelString(key, allCountries[key]));
    }

    return countriesList;
}

export function IntegrationsFilter(translation): DropdownModel[] {
    const integrationsFilterList =
        [
            new DropdownModel(IntegrationCategoryType.SSO, translation.instant('FILTER.INTEGRATIONS.SSO')),
            new DropdownModel(IntegrationCategoryType.PublicAPI, translation.instant('FILTER.INTEGRATIONS.PUBLICAPI')),
            new DropdownModel(IntegrationCategoryType.Payment, translation.instant('FILTER.INTEGRATIONS.PAYMENT')),
            new DropdownModel(IntegrationCategoryType.Webinar, translation.instant('FILTER.INTEGRATIONS.WEBINAR')),
        ];
    return integrationsFilterList;
}

export function IntegrationPaymentProviders(hasPaydesks: boolean): DropdownModelDisabled[] {
    const integrationPaymentProvidersList = [
            new DropdownModelDisabled(PaymentProviderType.Stripe, 'Stripe', false),
    ];
    if (hasPaydesks) {
        integrationPaymentProvidersList.push(
            new DropdownModelDisabled(PaymentProviderType.Halito, 'Paydesk', false)
        );
    }
    return integrationPaymentProvidersList;
}

export function CloneRepeatTypes(translation): DropdownModel[] {
    const cloneRepeatTypesList =
        [
            new DropdownModel(CloneRepeatType.Day, translation.instant('CLONE.REPEAT.1')),
            new DropdownModel(CloneRepeatType.Week, translation.instant('CLONE.REPEAT.2')),
            new DropdownModel(CloneRepeatType.Month, translation.instant('CLONE.REPEAT.3'))
        ];
    return cloneRepeatTypesList;
}

export function EvnInvActivityCategoryFilters(translation): DropdownModel[] {
    const list =
        [
            new DropdownModel(EvnInvActivityCategory.Confirmed, translation.instant('ACTIVITYCATEGORY.CONFIRMED')),
            new DropdownModel(EvnInvActivityCategory.Declined, translation.instant('ACTIVITYCATEGORY.DECLINED')),
            new DropdownModel(EvnInvActivityCategory.Created, translation.instant('ACTIVITYCATEGORY.CREATED')),
            new DropdownModel(EvnInvActivityCategory.Updated, translation.instant('ACTIVITYCATEGORY.UPDATED')),
            new DropdownModel(EvnInvActivityCategory.Deleted, translation.instant('ACTIVITYCATEGORY.DELETED')),
            new DropdownModel(EvnInvActivityCategory.Mail, translation.instant('ACTIVITYCATEGORY.MAIL')),
            new DropdownModel(EvnInvActivityCategory.Export, translation.instant('ACTIVITYCATEGORY.EXPORT')),
        ];
    return list;
}

export function ActivityTimeRanges(translation): DropdownModel[] {
    const list =
        [
            new DropdownModel(ActivityTimeRange.LastHour, translation.instant('ACTIVITYTIMERANGE.LASTHOUR')),
            new DropdownModel(ActivityTimeRange.Last4Hour, translation.instant('ACTIVITYTIMERANGE.LAST4HOUR')),
            new DropdownModel(ActivityTimeRange.Last12Hour, translation.instant('ACTIVITYTIMERANGE.LAST12HOUR')),
            new DropdownModel(ActivityTimeRange.Last24Hour, translation.instant('ACTIVITYTIMERANGE.LAST24HOUR')),
            new DropdownModel(ActivityTimeRange.Last48Hour, translation.instant('ACTIVITYTIMERANGE.LAST48HOUR')),
            new DropdownModel(ActivityTimeRange.LastWeek, translation.instant('ACTIVITYTIMERANGE.LASTWEEK')),
            new DropdownModel(ActivityTimeRange.Last2Weeks, translation.instant('ACTIVITYTIMERANGE.LAST2WEEKS')),
            new DropdownModel(ActivityTimeRange.LastMonth, translation.instant('ACTIVITYTIMERANGE.LASTMONTH')),
            new DropdownModel(ActivityTimeRange.Last3Month, translation.instant('ACTIVITYTIMERANGE.LAST3MONTH')),
        ];
    return list;
}

export function EventActivityCategoryFilters(translation): DropdownModel[] {
    const list =
        [
            new DropdownModel(EvnActivityCategory.Created, translation.instant('ACTIVITYCATEGORY.CREATED')),
            new DropdownModel(EvnActivityCategory.Updated, translation.instant('ACTIVITYCATEGORY.UPDATED')),
            new DropdownModel(EvnActivityCategory.Deleted, translation.instant('ACTIVITYCATEGORY.DELETED')),
            new DropdownModel(EvnActivityCategory.Export, translation.instant('ACTIVITYCATEGORY.EXPORT')),
        ];
    return list;
}

export function ContactActivityCategoryFilters(translation): DropdownModel[] {
    const list =
        [
            new DropdownModel(ConActivityCategory.Created, translation.instant('ACTIVITYCATEGORY.CREATED')),
            new DropdownModel(ConActivityCategory.Updated, translation.instant('ACTIVITYCATEGORY.UPDATED')),
            new DropdownModel(ConActivityCategory.Deleted, translation.instant('ACTIVITYCATEGORY.DELETED')),
            new DropdownModel(ConActivityCategory.Status, translation.instant('ACTIVITYCATEGORY.CONTACTSTATUS')),
            new DropdownModel(ConActivityCategory.Connector, translation.instant('ACTIVITYCATEGORY.CONTACTCONNECTOR')),
            new DropdownModel(ConActivityCategory.Export, translation.instant('ACTIVITYCATEGORY.EXPORT')),
        ];
    return list;
}

export function UserActivityCategoryFilters(translation): DropdownModel[] {
    const list =
        [
            new DropdownModel(UserActivityCategory.Created, translation.instant('ACTIVITYCATEGORY.CREATED')),
            new DropdownModel(UserActivityCategory.Updated, translation.instant('ACTIVITYCATEGORY.UPDATED')),
            new DropdownModel(UserActivityCategory.Deleted, translation.instant('ACTIVITYCATEGORY.DELETED')),
            new DropdownModel(UserActivityCategory.Account, translation.instant('ACTIVITYCATEGORY.ACCOUNT')),
        ];
    return list;
}

export function TenantAttActivityCategoryFilters(translation): DropdownModel[] {
    const list =
        [
            new DropdownModel(TenantAttActivityCategory.CheckIn, translation.instant('ACTIVITYCATEGORY.CHECKIN')),
            new DropdownModel(TenantAttActivityCategory.CheckOut, translation.instant('ACTIVITYCATEGORY.CHECKOUT')),
            new DropdownModel(TenantAttActivityCategory.NoShow, translation.instant('ACTIVITYCATEGORY.NOSHOW')),
            new DropdownModel(TenantAttActivityCategory.Confirmed, translation.instant('ACTIVITYCATEGORY.CONFIRMED')),
            new DropdownModel(TenantAttActivityCategory.Declined, translation.instant('ACTIVITYCATEGORY.DECLINED')),
        ];
    return list;
}


export function EvnAttActivityCategoryFilters(translation): DropdownModel[] {
    const list =
        [
            new DropdownModel(EvnAttActivityCategory.CheckIn, translation.instant('ACTIVITYCATEGORY.CHECKIN')),
            new DropdownModel(EvnAttActivityCategory.CheckOut, translation.instant('ACTIVITYCATEGORY.CHECKOUT')),
            new DropdownModel(EvnAttActivityCategory.NoShow, translation.instant('ACTIVITYCATEGORY.NOSHOW')),
            new DropdownModel(EvnAttActivityCategory.Invitations, translation.instant('ACTIVITYCATEGORY.INVITATIONS')),
            new DropdownModel(EvnAttActivityCategory.Export, translation.instant('ACTIVITYCATEGORY.EXPORT')),
        ];
    return list;
}

export function EvnTicketActivityCategoryFilters(translation): DropdownModel[] {
    const list =
        [
            new DropdownModel(EvnTicketActivityCategory.CheckIn, translation.instant('ACTIVITYCATEGORY.CHECKIN')),
            new DropdownModel(EvnTicketActivityCategory.CheckOut, translation.instant('ACTIVITYCATEGORY.CHECKOUT')),
        ];
    return list;
}

export function SupportPeriodTypes(translation): DropdownModel[] {
    const list =
        [
            new DropdownModel(SupportPeriodType.Permanent, translation.instant('SUPPORTPERIODTYPE.PERMANENT')),
            new DropdownModel(SupportPeriodType.Days2, translation.instant('SUPPORTPERIODTYPE.HOURS', { hours: 48 })),
            new DropdownModel(SupportPeriodType.Days1, translation.instant('SUPPORTPERIODTYPE.HOURS', { hours: 24 })),
            new DropdownModel(SupportPeriodType.Hours8, translation.instant('SUPPORTPERIODTYPE.HOURS', { hours: 8 })),
            new DropdownModel(SupportPeriodType.Hours4, translation.instant('SUPPORTPERIODTYPE.HOURS', { hours: 4 })),
            new DropdownModel(SupportPeriodType.Hours2, translation.instant('SUPPORTPERIODTYPE.HOURS', { hours: 2 })),
        ];
    return list;
}

export function ReportPeriodTypes(translation): DropdownModel[] {
    const list =
        [
            new DropdownModel(ReportPeriodType.Last24Hour, translation.instant('ACTIVITYTIMERANGE.LAST24HOUR')),
            new DropdownModel(ReportPeriodType.Last48Hour, translation.instant('ACTIVITYTIMERANGE.LAST48HOUR')),
            new DropdownModel(ReportPeriodType.LastWeek, translation.instant('ACTIVITYTIMERANGE.LASTWEEK')),
            new DropdownModel(ReportPeriodType.Last2Weeks, translation.instant('ACTIVITYTIMERANGE.LAST2WEEKS')),
            new DropdownModel(ReportPeriodType.LastMonth, translation.instant('ACTIVITYTIMERANGE.LASTMONTH')),
            new DropdownModel(ReportPeriodType.Last3Month, translation.instant('ACTIVITYTIMERANGE.LAST3MONTH')),
            new DropdownModel(ReportPeriodType.Last6Month, translation.instant('ACTIVITYTIMERANGE.LAST6MONTH')),
            new DropdownModel(ReportPeriodType.LastYear, translation.instant('ACTIVITYTIMERANGE.LASTYEAR')),
        ];
    return list;
}

export function ReportTypes(translation): DropdownModel[] {
    const list =
        [
            new DropdownModel(ReportType.Contact, translation.instant('REPORTTYPE.CONTACT')),
            new DropdownModel(ReportType.Invitation, translation.instant('REPORTTYPE.INVITATION')),
        ];
    return list;
}

export function ReportFolderTypes(translation): DropdownModel[] {
    const list =
        [
            new DropdownModel(ReportFolderType.Public, translation.instant('REPORTFOLDER.PUBLIC')),
            new DropdownModel(ReportFolderType.Private, translation.instant('REPORTFOLDER.PRIVATE')),
        ];
    return list;
}

export function ToggleFilter(translation, toggleFilterType: ToggleFilterType): DropdownModelString[] {
    let toggleFilterList = [];
    switch (toggleFilterType) {
        case ToggleFilterType.Utm:
            toggleFilterList =
                [
                    new DropdownModelString('accountOwnerFilter', translation.instant('INPUT.OWNER.LONG.LABEL')),
                    new DropdownModelString('ticketHolderFilter', translation.instant('INPUT.TICKETHOLDER.LABEL')),
                    new DropdownModelString('locationDateTimeFilter', translation.instant('INPUT.VENUENAME.LABEL')),
                    new DropdownModelString('medium', 'utm_medium'),
                    new DropdownModelString('source', 'utm_source'),
                    new DropdownModelString('campaign', 'utm_campaign'),
                    new DropdownModelString('term', 'utm_term'),
                    new DropdownModelString('content', 'utm_content'),
                    new DropdownModelString('campaingId', 'utm_id')
                ];
            break;
    }
    return toggleFilterList;
}

export function ScannerActionsFilter(translation): DropdownModel[] {
    const list =
        [
            new DropdownModel(ScannerActionType.CheckedIn, translation.instant('ACTION.CHECKIN.TEXT')),
            new DropdownModel(ScannerActionType.CheckedOut, translation.instant('ACTION.CHECKOUT.TEXT'))
        ];
    return list;
}

export function GalleryAccess(translation): DropdownModel[] {
    const galleryVisibilityTypesList =
        [
            new DropdownModel(GalleryAccessType.All, translation.instant('GALLERYACCESSTYPE.ALL')),
            new DropdownModel(GalleryAccessType.Registered, translation.instant('GALLERYACCESSTYPE.REGISTERED')),
            new DropdownModel(GalleryAccessType.CheckedIn, translation.instant('GALLERYACCESSTYPE.CHECKEDIN'))
        ];
    return galleryVisibilityTypesList;
}

export function SpeakerDisplayType(translation): DropdownModel[] {
    const speakerDisplayTypesList =
        [
            new DropdownModel(SpeakersPageDisplayType.List, translation.instant('SPEAKERSDISPLAYTYPE.LIST')),
            // Tile (value 2) renders a grid of cards; reuse the existing localized "Grid" label.
            new DropdownModel(SpeakersPageDisplayType.Tile, translation.instant('SPEAKERSDISPLAYTYPE.GRID'))
        ];
    return speakerDisplayTypesList;
}

export function WorkshopDisplayType(translation): DropdownModel[] {
    const speakerDisplayTypesList =
        [
            new DropdownModel(WorkshopsPageDisplayType.List, translation.instant('SPEAKERSDISPLAYTYPE.LIST')),
            // Tile (value 2) renders a grid of cards; reuse the existing localized "Grid" label.
            new DropdownModel(WorkshopsPageDisplayType.Tile, translation.instant('SPEAKERSDISPLAYTYPE.GRID'))
        ];
    return speakerDisplayTypesList;
}

export function CustomEventFieldsTypes(translation): any {
    const customEventFieldsTypesList = [
        {
            id: CustomEventFieldType.FreeText,
            text: translation.instant('ROUTES.SETTINGS.CUSTOMCONTACTFIELDS.FIELDTYPE.FREETEXT'),
        },
        {
            id: CustomEventFieldType.SingleSelect,
            text: translation.instant('ROUTES.SETTINGS.CUSTOMCONTACTFIELDS.FIELDTYPE.SINGLESELECT'),
        },
        {
            id: CustomEventFieldType.MultipleSelect,
            text: translation.instant('ROUTES.SETTINGS.CUSTOMCONTACTFIELDS.FIELDTYPE.MULTIPLESELECT'),
        },
        {
            id: CustomEventFieldType.Boolean,
            text: translation.instant('ROUTES.SETTINGS.CUSTOMCONTACTFIELDS.FIELDTYPE.BOOLEAN'),
        }
    ];
    return customEventFieldsTypesList;
}

export function NotificationTypes(translation): DropdownModel[] {
    const taskStatusTypesList =
        [
            new DropdownModel(NotificationType.Confirmation, translation.instant('INPUT.NOTIFICATIONS.COFIRMATION.LABEL')),
            new DropdownModel(NotificationType.UpdateConfirmation, translation.instant('INPUT.NOTIFICATIONS.UPDATECONFIRMATION.LABEL')),
            new DropdownModel(NotificationType.Checkin, translation.instant('INPUT.NOTIFICATIONS.CHECKIN.LABEL')),
            new DropdownModel(NotificationType.Cancelled, translation.instant('INPUT.NOTIFICATIONS.CANCELLED.LABEL'))
        ];
    return taskStatusTypesList;
}

export function SetDateBasedOnTimeString(time: string): Date {
    if (!time?.includes(':')) { return; };
    const hoursAndMinutesList: string[] = time.split(':');
    const timeInMiliseconds = ((+hoursAndMinutesList[0]) * 60 * 60 + (+hoursAndMinutesList[1]) * 60) * 1000;
    const helperDate = new Date(timeInMiliseconds);
    return new Date(helperDate.getTime() + helperDate.getTimezoneOffset() * 60000);
}

/**
 * Converts a date picker value into the value that is stored for a date custom field: 12:00 UTC on the
 * calendar date that is shown in the picker. Noon UTC keeps the calendar date stable when the value is
 * read back and converted to local time.
 * The calendar date is read from the picker value first, so the conversion is idempotent: saving a value
 * that was loaded from the api again keeps the same date, instead of shifting the stored moment forward.
 */
export function SetUtcDateValueBasedOnDatePickerValue(datePickerValue: any): Date {
    if (!datePickerValue) { return null; };
    const localDate = moment(datePickerValue);
    if (!localDate.isValid()) { return null; };
    return moment.utc(localDate.format('YYYY-MM-DD')).add(12, 'hours').toDate();
}

export function SetStringTimeValueBasedOnTimePickerValue(timePickerValue: string): string {
    if (!timePickerValue) { return; };
    const time = new Date(timePickerValue);
    const hours = time.getHours().toString();
    const minutes = time.getMinutes().toString().length === 1 ? '0' + time.getMinutes() : time.getMinutes();
    return `${hours}:${minutes}`;
}

export function FooterLayoutTypes(translation): DropdownModel[] {
    const footerLayoutTypesList =
        [
            new DropdownModel(FooterLayoutType.Single, '1' + ' ' + translation.instant('COLUMN.SINGLE.LABEL') + ' ' + '(100%)'),
            new DropdownModel(FooterLayoutType.Double5050, '2' + ' ' + translation.instant('COLUMN.MULTIPLE.LABEL') + ' ' + '(50% | 50%)'),
            new DropdownModel(FooterLayoutType.Double2575, '2' + ' ' + translation.instant('COLUMN.MULTIPLE.LABEL') + ' ' + '(25% | 75%)'),
            new DropdownModel(FooterLayoutType.Double7525, '2' + ' ' + translation.instant('COLUMN.MULTIPLE.LABEL') + ' ' + '(75% | 25%)'),
            new DropdownModel(FooterLayoutType.Triple333333, '3' + ' ' + translation.instant('COLUMN.MULTIPLE.LABEL') + ' ' + '(33% | 33% | 33%)'),
            new DropdownModel(FooterLayoutType.Triple252550, '3' + ' ' + translation.instant('COLUMN.MULTIPLE.LABEL') + ' ' + '(25% | 25% | 50%)'),
            new DropdownModel(FooterLayoutType.Triple255025, '3' + ' ' + translation.instant('COLUMN.MULTIPLE.LABEL') + ' ' + '(25% | 50% | 25%)'),
            new DropdownModel(FooterLayoutType.Triple502525, '3' + ' ' + translation.instant('COLUMN.MULTIPLE.LABEL') + ' ' + '(50% | 25% | 25%)'),
            new DropdownModel(FooterLayoutType.Quadruple, '4' + ' ' + translation.instant('COLUMN.MULTIPLE.LABEL') + ' ' + '(25% | 25% | 25% | 25%)')
        ];
    return footerLayoutTypesList;
}

export function ContentContextTypes(translation): DropdownModel[] {
    const contentContextTypesList =
        [
            new DropdownModel(ContentContextType.Page, translation.instant('CONTENTCONTEXT.PAGE')),
            new DropdownModel(ContentContextType.Email, translation.instant('CONTENTCONTEXT.EMAIL'))
        ];
    return contentContextTypesList;
}

export function AlignmentTypes(translation): DropdownModel[] {
    const alignmentList =
        [
            new DropdownModel(AlignmentType.Left, translation.instant('ALIGNMENT.LEFT')),
            new DropdownModel(AlignmentType.Center, translation.instant('ALIGNMENT.CENTER')),
            new DropdownModel(AlignmentType.Right, translation.instant('ALIGNMENT.RIGHT'))
        ];
    return alignmentList;
}

export function MediaTypes(translation, type: ContentContextType): DropdownModel[] {
    const mediaTypesList =
        [
            new DropdownModel(ContentMediaType.Image, translation.instant('MEDIATYPE.IMAGE')),
            new DropdownModel(ContentMediaType.AnimatedImage, translation.instant('MEDIATYPE.ANIMATEDIMAGE'))
        ];
    if (type === ContentContextType.Page) {
        mediaTypesList.push(
            new DropdownModel(ContentMediaType.Video, translation.instant('MEDIATYPE.VIDEO'))
        );
    }
    return mediaTypesList;
}

export function MenuPositionTypes(translation): DropdownModel[] {
    const menuPositionTypesList =
        [
            new DropdownModel(MenuPositionType.Banner, translation.instant('MENUPOSITION.BANNER')),
            new DropdownModel(MenuPositionType.Content, translation.instant('MENUPOSITION.CONTENT'))
        ];
    return menuPositionTypesList;
}

export function PromoCodeStatusFilter(translation): DropdownModel[] {
    const promoCodeStatusFilterList =
        [
            new DropdownModel(1, translation.instant('PROMOCODESTATUS.LABEL.ACTIVE')),
            new DropdownModel(2, translation.instant('PROMOCODESTATUS.LABEL.NOTSTARTED')),
            new DropdownModel(3, translation.instant('PROMOCODESTATUS.LABEL.EXPIRED'))
        ];
    return promoCodeStatusFilterList;
}

export function PromoTypeDropdown(translation): DropdownModel[] {
    const promoTypeList =
        [
            new DropdownModel(1, translation.instant('PROMOTION.LABEL.FIXEDDISCOUNT')),
            new DropdownModel(2, translation.instant('PROMOTION.LABEL.PERCENTAGEDISCOUNT')),
            new DropdownModel(3, translation.instant('PROMOTION.LABEL.NEWPRICE')),
            new DropdownModel(4, translation.instant('PROMOTION.LABEL.BUDGET'))
        ];
    return promoTypeList;
}

export function CodeTypeDropdown(translation): DropdownModel[] {
    const codeTypeList =
        [
            new DropdownModel(1, translation.instant('CODE.LABEL.NONE')),
            new DropdownModel(2, translation.instant('CODE.LABEL.BARCODE')),
            new DropdownModel(3, translation.instant('CODE.LABEL.QRCODE'))
        ];
    return codeTypeList;
}

export function FooterCopyModes(translation): DropdownModel[] {
    const list =
        [
            new DropdownModel(FooterCopyMode.LooseCopy, translation.instant('FOOTERCOPYMODE.LOOSE')),
            new DropdownModel(FooterCopyMode.ManagedCopy, translation.instant('FOOTERCOPYMODE.MANAGED'))
        ];
    return list;
}

export function CopyModes(translation): DropdownModel[] {
    const list =
        [
            new DropdownModel(CopyMode.LooseCopy, translation.instant('FOOTERCOPYMODE.LOOSE')),
            new DropdownModel(CopyMode.ManagedCopy, translation.instant('FOOTERCOPYMODE.MANAGED'))
        ];
    return list;
}

export function ImportInvitationColumnLevels(translation, showIgnore: boolean = true): DropdownModel[] {
    const items = [];

    if (showIgnore) {
        items.push(new DropdownModel(ImportInvitationColumnLevel.Ignore, translation.instant('IMPORTINVITATIONCOLUMNLEVEL.IGNORE')));
    }

    items.push(
        new DropdownModel(ImportInvitationColumnLevel.Contact, translation.instant('IMPORTINVITATIONCOLUMNLEVEL.CONTACT')),
        new DropdownModel(ImportInvitationColumnLevel.InvitationOnly, translation.instant('IMPORTINVITATIONCOLUMNLEVEL.INVITATIONONLY'))
    );

    return items;
}

export function ExportTypes(translation): DropdownModel[] {
    const exportTypesList =
        [
            new DropdownModel(1, translation.instant('EXPORTTYPE.INVITATION')),
            new DropdownModel(2, translation.instant('EXPORTTYPE.ATTENDEE')),
            new DropdownModel(3, translation.instant('EXPORTTYPE.CONTACT')),
            new DropdownModel(4, translation.instant('EXPORTTYPE.REPORTS')),
            new DropdownModel(5, translation.instant('EXPORTTYPE.REGISTRATIONDETAILS')),
            new DropdownModel(6, translation.instant('EXPORTTYPE.MAILSTATISTICS')),
            new DropdownModel(7, translation.instant('EXPORTTYPE.INTERACTIONS')),
            new DropdownModel(8, translation.instant('EXPORTTYPE.UTMSTATISTICS'))
        ];
    return exportTypesList;
}

export function ExportStatuses(translation): DropdownModel[] {
    const exportStatusesList =
        [
            new DropdownModel(1, translation.instant('EXPORTSTATUS.INITIALIZED')),
            new DropdownModel(2, translation.instant('EXPORTSTATUS.PROCESSING')),
            new DropdownModel(3, translation.instant('EXPORTSTATUS.READY')),
            new DropdownModel(4, translation.instant('EXPORTSTATUS.FAILED'))
        ];
    return exportStatusesList;
}

export function DefaultSmartFields(translation): DropdownModelString[] {
    const defaultSmartFieldList =
        [
            new DropdownModelString('gender', translation.instant('SMARTFIELDS.GENDER')),
            new DropdownModelString('type', translation.instant('SMARTFIELDS.CONTACTTYPE'))
        ];
    return defaultSmartFieldList;
}

export function GenderSmartFields(translation): DropdownModelString[] {
    const genderSmartFieldList =
        [
            new DropdownModelString('male', translation.instant('SMARTFIELDS.GENDER.MALE')),
            new DropdownModelString('female', translation.instant('SMARTFIELDS.GENDER.FEMALE'))
        ];
    return genderSmartFieldList;
}

export function SortByFieldOptions(translation): DropdownModelString[] {
    const sortByFieldList =
        [
            new DropdownModelString('lastInvited', translation.instant('ROUTES.EVENTDETAIL.COMPONENTS.INVITATIONLIST.MODAL.ADVANCEDSORTING.SORTBYFIELD.LASTINVITED.LABEL')),
            new DropdownModelString('lastAttended', translation.instant('ROUTES.EVENTDETAIL.COMPONENTS.INVITATIONLIST.MODAL.ADVANCEDSORTING.SORTBYFIELD.LASTATTENDED.LABEL')),
            new DropdownModelString('lastRegistered', translation.instant('ROUTES.EVENTDETAIL.COMPONENTS.INVITATIONLIST.MODAL.ADVANCEDSORTING.SORTBYFIELD.LASTREGISTERED.LABEL')),
            new DropdownModelString('lastNoShow', translation.instant('ROUTES.EVENTDETAIL.COMPONENTS.INVITATIONLIST.MODAL.ADVANCEDSORTING.SORTBYFIELD.LASTNOSHOW.LABEL'))
        ];
    return sortByFieldList;
}

export function ListDeleteInactiveContacts(translation): DropdownModel[] {
    const listDeleteInactiveContacts =
        [
            new DropdownModel(1, translation.instant('DELETE.MANUAL')),
            new DropdownModel(2, translation.instant('DELETE.AUTOMATED'))
        ];
    return listDeleteInactiveContacts;
}

export function PublicEventSsoModes(translation): DropdownModel[] {
  return [
    new DropdownModel(PublicEventSsoMode.Introspection, translation.instant('PUBLICEVENTSSO.MODE.INTROSPECTION')),
    new DropdownModel(PublicEventSsoMode.UserInfo,      translation.instant('PUBLICEVENTSSO.MODE.USERINFO')),
    new DropdownModel(PublicEventSsoMode.AuthorizeUser, translation.instant('PUBLICEVENTSSO.MODE.AUTHORIZEUSER')),
  ];
}

export function PublicEventSsoAuthTypes(translation): DropdownModel[] {
  return [
    new DropdownModel(PublicEventSsoAuthType.None,                    translation.instant('PUBLICEVENTSSO.AUTHTYPE.NONE')),
    new DropdownModel(PublicEventSsoAuthType.Basic,                   translation.instant('PUBLICEVENTSSO.AUTHTYPE.BASIC')),
    new DropdownModel(PublicEventSsoAuthType.OAuth2ClientCredentials, translation.instant('PUBLICEVENTSSO.AUTHTYPE.OAUTH2CLIENTCREDENTIALS')),
  ];
}

export function PublicEventSsoAttributes(translation): DropdownModel[] {
  return [
    new DropdownModel(PublicEventSsoAttribute.UserId,    translation.instant('PUBLICEVENTSSO.ATTRIBUTE.USERID')),
    new DropdownModel(PublicEventSsoAttribute.FirstName, translation.instant('PUBLICEVENTSSO.ATTRIBUTE.FIRSTNAME')),
    new DropdownModel(PublicEventSsoAttribute.LastName,  translation.instant('PUBLICEVENTSSO.ATTRIBUTE.LASTNAME')),
    new DropdownModel(PublicEventSsoAttribute.Email,     translation.instant('PUBLICEVENTSSO.ATTRIBUTE.EMAIL')),
  ];
}

